import { Autocomplete, Box, Button, Checkbox, Chip, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Modal, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../OutpatientHome.css'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { Demo_Layout_Default_JSON, Medical_History_Blood_Group } from '../../../../Utility/Constants';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import RefreshIcon from '@mui/icons-material/Refresh';
import { DateTime } from 'luxon';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import Webcam from "react-webcam";
import { Close } from '@material-ui/icons';
import { clearCachevalue, getCachevalue, setCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { CommonImgPreviewPop, CommonPatientDetails, DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { Colors } from '../../../../Styles/Colors';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { AmountFormat, CheckAccessFunc, dataURItoFile, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import Loader from '../../../../Components/Loader';
import moment from "moment";
import { City, Country, State } from 'country-state-city';
import PrintPreviewPop from '../../../../Components/Common Components/PrintPreviewPop';

const videoConstraints = {
  width: 500,
  height: 420,
  facingMode: "user",
  borderRadius: 100
};

const CheckImage = new Set(["aadharProofImgCap", "panProofImgCap", "passportProofImgCap", "rationProofImgCap", "dlProofImgCap"])
class CreateApppointment extends Component {
  constructor(props) {
    super(props);
    this.webcamRef = React.createRef();
    this.state = {
      layoutData: [],
      mandotory_count: '03',
      refDoctorData: [],
      refSourceData: [],
      CorporateList: [],
      referredBy: "",
      refferalValue: "",
      referralSource: "",
      referralStaff: "",
      refferedType:"",
      mobile_no: "",
      first_name: "",
      age: "",
      dob: null,
      gender: "",
      title: "",
      middle_name: "",
      surname: "",
      address_1: "",
      address_2: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      employer_id: "",
      employee_id: "",
      email_id: "",
      marital_status: "",
      father_husband_name: "",
      father_husband_age: "",
      occupation: "",
      emergency_contact_person: "",
      emergency_contact_mobile: "",
      relationship: "",
      docDocument: null,
      aadharProof: null,
      panProof: null,
      passportProof: null,
      rationProof: null,
      dlProof: null,
      aadharProofImg: null,
      panProofImg: null,
      passportProofImg: null,
      rationProofImg: null,
      dlProofImg: null,
      aadharProofImgCap: null,
      panProofImgCap: null,
      passportProofImgCap: null,
      rationProofImgCap: null,
      dlProofImgCap: null,
      doctorList: [],
      filteredDocList: [],
      spcInfo: [],
      tagDetails: [],
      AppointmentTypeList: [],
      selectedDocId: null,
      selectedSpecId: null,
      selectedTagId: null,
      selectedAppointTypeId: null,
      appointmentDateTime: new Date(),
      purposeOfVisit: "",
      MandatoryLabels: [],
      CorporateList: [],
      patient_img: null,
      temp_patient_img: null,
      ProfilePicClicked: false,
      pancard_number: "",
      ration_card_number: "",
      dl_number: "",
      passport_number: "",
      aadhar_card_number: "",
      SelectedPatientID: "",
      SelectedDocSRC: null,
      SameMobileNumPatients: [],
      isForIPUpdate: false,
      receive_email: false,
      receive_whatsapp: false,
      receive_sms: true,
      refDocumentSelected: null,
      insurance_company_name: null,
      policy_number: "", 
      insurance_id: null,
      isRefreshing:false,
      guardian: "",
      DateOpen: false,
      isPatientCreated: false,
      CreatedPatientId: null,
      createdBy: '',
      modifiedBy: '',
      NurseList: [],
      OpthometristList: [],
      selectedOptometrist: null,
      selectedNurseId: null,
      mother_name:"",
      mother_age:"",
      POVList: [],
      InsuranceList:[],
      NewInsurance : false,
      POVList: [],
      RequestedPatientData: {},
      slotList: [],
      selectedSlot: "",
      old_referral_no: "",
      dateLimit: 90,
      dateLimitType: 'Days',
      QRPatientData: {},
      creditType: '',
      confirmationPop: false,
      appointmentId: "",
      admissionId: "",
      DisableBtn: false,
      followupID: null,
      isDoctorMandatory :  JSON.parse(localGetItem("loggedInUserInfo"))?.token_gen_type === "Specialization" ? false : true,
      hasAbha: localGetItem("has_abha_service") === "true" ? true : false,
      isQmsConfig: false,
      manuallySelected: false,
      manuallyChanged: false,
      isFrontCamera: true, 
      facingMode : 'user', 
      devices : [],
      selectedFatHusName:'',
      disableNameGenderEdit: false,
      SelectedPatientType: null,
      PatientTypeConfig: false,
      patient_type: '',
      selectedPatientData: null,
      refTypeData :["Source","Doctor","Staff"],
      medicalBloodGroup: Medical_History_Blood_Group,
      blood_group: '',
      clinic_id: localGetItem('clinicId'),
      ccn_number: '',
      imgCapClked: false,
      slcIdKey: "",
      pdfData: '',
      doctorToken: null,
      pdfPreview: false,
      duplicatedDocDocument:"",
      duplicateAadharProof:"",
      duplicatePanProof:"",
      duplicatePassportProof:"",
      duplicateRationProof:"",
      duplicateDlProof:"",
      caretaker_id: '',
      refferalDesc: '',
      allow_referral_field: false,
      isUser: false,
      district: '',
      abha_health_id: '',
      rchid:'',
      rchError: false,
      selectCreditType: JSON.parse(localGetItem("allow_patient_credit_bills")) ? 'Patient credit' : null,
      hasFutureAppointment:false,
      futureAppointments:[],
      hasValiuptoDate:[],
      DialogFuture:false,
      hasValid: false,
    }
    this.uploadImage = React.createRef();
  }

  componentDidMount() {
    let city_name = localGetItem('city_name')
    let state_name = localGetItem('state_name')
    let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
    let stateList = State.getStatesOfCountry(List?.countryCode)
    let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
    this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList}, () => {
      this.getReferralDctorData()
      this.getRefSourceData()
      this.getStaffRefferalData()
      this.GetCorporateList()
      this._getDoctorDetails();
      this._getSpecInfo();
      this._getTagDetails();
      this._getCorpList();
      this._getAppointTypeList()
      this.getNurseList()
      if(!this.props.isFromIP && !this.props.isForOPUpdate && !this.props.fromViewGraphics && localGetItem("automatic_opthometrist_mapping") === "false"){
        this.getOpthometristList()
      }
      this.getInsuranceList()
      this.getConnectedDevices()

      let patientDetails = getCachevalue("patientData")
      let patients = JSON.parse(patientDetails)
      let POVList = localGetItem("PurposeOfVisit") === null ? '[]' : localGetItem("PurposeOfVisit")
      let array = []
      let userData = JSON.parse(localGetItem("loggedInUserInfo"))
      let permissionAccess = userData?.permission_access
      this.setState({ isQmsConfig: userData?.is_qms_enabled ? userData?.is_qms_enabled : false, disableNameGenderEdit: (permissionAccess?.common?.is_demographics_edit && userData?.is_user) ? true : false, 
        allow_referral_field: !permissionAccess?.common?.is_referral_field_edit, isUser: userData?.is_user ? true : false
       })
      JSON.parse(POVList)?.forEach(element => array.push(element.reason));
      let patient_type_config = JSON.parse(localGetItem("patient_type_config_in_demographics"))

      if (this.props.isForOPUpdate) {
        this.LoaderFunction(true)
        this.setState({ SelectedPatientID: patients?.patient_id, SelectedPatientType: patients?.patient_type, PatientTypeConfig: patient_type_config ? patient_type_config : false, selectedPatientData: patients }, () => { this.getPatientDemographics() })
      }
      else if ((this.props.isFromIP || this.props.fromViewGraphics) && this.props.PatientDetailBack && Object.keys(this.props.PatientDetailBack).length !== 0) {
        this.LoaderFunction(true)
        this.setState({ SelectedPatientID: this.props.PatientDetailBack?.patient_id, isForIPUpdate: true, SelectedPatientType: patients?.patient_type }, () => { this.getPatientDemographics() })
      }
      if (getCachevalue("OP_CreateAppointment_PatientId")) {
        this.LoaderFunction(true)
        this.setState({
          SelectedPatientID: getCachevalue("OP_CreateAppointment_PatientId")
        }, () => { this.getPatientDemographics() })
      }

      if (this.props.history?.location?.state?.fromOpRequest) {
        this.getIpPatientData(this.props.history?.location?.state?.patient_id)
      }

      if (getCachevalue("QRRequestPatientData") && getCachevalue("QRRequestPatientData") !== JSON.stringify(this.state.QRPatientData)) {
        let Data = JSON.parse(getCachevalue("QRRequestPatientData"))
        this.setState({
          QRPatientData: Data,
          first_name: Data?.patient_name ? Data?.patient_name : "",
          mobile_no: Data?.mobile_number ? Data?.mobile_number : "",
          address_1: Data?.address ? Data?.address : "",
          email_id: Data?.email ? Data?.email : "",
          gender: Data?.gender ? Data?.gender : "",
          pin_code: Data?.pincode ? Data?.pincode : "",
          referralSource: Data?.referral_source ? Data?.referral_source : "",
          father_husband_name: Data?.father_name ? Data?.father_name : "",
          occupation: Data?.occupation ? Data?.occupation : "",
          guardian: Data?.guardian_name ? Data?.guardian_name : "",
          marital_status: Data?.marital_status ? (Data?.marital_status === 'Unmarried' ? 'Single' : Data?.marital_status) : "",
          aadhar_card_number: Data?.aadhar_number ? Data?.aadhar_number : "",
          selectedFatHusName: Data?.relationship_label ? Data?.relationship_label : '',
          address_1: Data.address_line_1 ? Data.address_line_1 : Data?.address ? Data?.address : '',
          address_2: Data.address_line_2,
          country_code: this.state.AllCountry.find((item) => (item.name === Data?.country))?.isoCode,
          AllStates: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === Data?.country))?.isoCode),
          state_code: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === Data?.country))?.isoCode).find((item) => (item.name === Data?.state_name))?.isoCode,
          city: Data?.city_name,
          district: Data?.district,
          title: Data?.title,
          purposeOfVisit: Data?.purpose_of_visit ? Data?.purpose_of_visit : '',
          patient_type: Data?.patient_type ? Data?.patient_type : null,
          blood_group: Data?.blood_group ? Data?.blood_group : '',
          ccn_number: Data?.ccn_number ? Data?.ccn_number : '',
          caretaker_id: Data?.caretaker_id ? Data?.caretaker_id : '',
          rchid: Data?.rchid ? Data?.rchid : '',
        }, () => {
          if (Data?.age) {
            this.setState({
              age: Data?.age,
              dob: Data.dob !== null ? new Date(Data?.dob) : this.handleFindApproxDob(Data?.age)
            })
          }
          if (Data.patient_id == null) {
            this.CheckExistingPatients()
          } else {
            setCachevalue(Data.patient_id, "OP_CreateAppointment_PatientId")
            this.setState({
              SelectedPatientID: Data.patient_id,
              SameMobileNumPatients: []
            }, () => { this.getPatientDemographics() })
          }
        })
      }

      if (getCachevalue("AppRequestPatientData") && getCachevalue("AppRequestPatientData") !== JSON.stringify(this.state.RequestedPatientData)) {
        let Data = JSON.parse(getCachevalue("AppRequestPatientData"))
        this.setState({
          RequestedPatientData: Data,
          first_name: Data?.first_name ? Data?.first_name : "",
          mobile_no: Data?.mobile_number ? Data?.mobile_number : "",
          selectedAppointTypeId: Data?.appoinment_type ? Data?.Data?.appoinment_type : null,
          purposeOfVisit: Data?.message ? Data?.message : "",
          followupID: this.props.history?.location?.state?.followupID ? this.props.history?.location?.state?.followupID : null,
          address_1: Data.address_line_1 ? Data.address_line_1 : "",
          address_2: Data.address_line_2 ? Data.address_line_2 : "",
          country_code: this.state.AllCountry?.find((item) => (item.name === Data?.country))?.isoCode,
          AllStates: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === Data?.country))?.isoCode),
          state_code: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === Data?.country))?.isoCode)?.find((item) => (item.name === Data?.state_name))?.isoCode,
          city: Data?.city_name ? Data?.city_name : "",
          pin_code: Data.pincode ? Data.pincode : null,
          age: typeof Data?.age === "string" ? Data?.age?.includes("Y") ? Data?.age?.replace('Y', '') : Data?.age : (Data?.age ? Data?.age : null),
          gender: Data.gender ? Data.gender : "",
          // appointmentDateTime: new Date(`${Data?.appointment_date} ${Data?.appointment_time}`),
        }, () => {
          if (Data?.age !== "") {
            this.setState({
              age: Data?.age,
              dob: this.handleFindApproxDob(typeof Data?.age === "string" ? Data?.age?.includes("Y") ? Data?.age?.replace('Y', '') : Data?.age : (Data?.age ? Data?.age : null))
            })
          }
          if (Data?.patient_id) {
            this.setState({
              SelectedPatientID: Data?.patient_id ? Data?.patient_id : ""
            }, () => {
              this.LoaderFunction(true)
              this.getPatientDemographics()
            })
          }
        })
      }

      if (array.length > 0) {
        this.setState({
          POVList: array
        })
      }
      if (!this.props.isFromOT) {
        this.getQmsConfig()
        this.getDemoLayout()
      }

    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fromViewGraphics && prevProps.PatientDetailBack && Object.keys(prevProps.PatientDetailBack).length !== 0 && prevProps.PatientDetailBack?.patient_id !== this.state.SelectedPatientID) {
      this.LoaderFunction(true)
      this.setState({ SelectedPatientID: prevProps.PatientDetailBack?.patient_id, isForIPUpdate: true }, () => { this.getPatientDemographics() })
    }
    if (this.props != prevProps) {
      let DocId = this.state.doctorList.find(item => item.doctor_id === this.state.RequestedPatientData?.doctor_id)
      let SpecID = this.state.spcInfo.find(item => item.id === DocId?.specialization_id)
      if (Object.keys(this.state.RequestedPatientData).length > 0 && !this.props?.is_Nurse) {
        this.setState({
          selectedDocId: this.state.RequestedPatientData?.doctor_id ? (DocId ? DocId : null) : null,
          selectedSpecId: this.state.RequestedPatientData?.doctor_id ? (SpecID ? SpecID : null) : null,
          selectedNurseId: null,
          purposeOfVisit: this.state.purposeOfVisit ? this.state.purposeOfVisit : SpecID?.purpose_of_visit ? SpecID?.purpose_of_visit : ''
        }, () => {
          if (DocId) {
            let states = this.state
            let docDetail = DocId
            let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter((item) => (item["specialization_id"] === docDetail["specialization_id"]))
            states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
            this.setState({ states })
          }
      })
      } else {
        this.setState({
          selectedDocId: null,
          selectedSpecId: null,
          selectedNurseId: null,
          selectedOptometrist: null,
        })
      }

    }
  }

  getSlotIntervel = () => {
    var date = new Date(this.state.appointmentDateTime)
    var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
    this.LoaderFunction(true)
    try {
      RestAPIService.getAll(Serviceurls.SCHEDULE_TIME_GET + "?date=" + appointment_date + "&doctor_id=" + this.state.selectedDocId?.doctor_id)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              slotList: this.state.selectedAppointTypeId?.appoinment_type === "Tele Consultation" ?  response.data.data?.tele : (response.data.data?.normal || []),
              slotPopup: true
            }, () => { this.LoaderFunction(false) })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
          this.LoaderFunction(false)
        })

    } catch (e) {
      this.errorMessage(e.message)
      this.LoaderFunction(false)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message,
      DisableBtn: false,
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message,
      DisableBtn: false,
    })
  }

  getPatientDemographics = (data) => {
    try {
      this.LoaderFunction(true)
      RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + "?patient_id=" + this.state.SelectedPatientID)
        .then(response => {
          if (response.data.status === "success") {
            this.assignDemographicsData(response.data.data)
            if (data) {
              let list = response?.data?.data;
              list["patient_account_number"] = data?.patient_account_number;
              setCachevalue(JSON.stringify(list), "IppatientData");
              this.props.IpPatientUpdateSuccess(list);
            }
            this.getFutureAppointmentData()
          }
        })
        .catch(error => {

        });
    }
    catch (e) {

    }
  }

  getNurseList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_STAFF_LIST).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              NurseList: response.data.data,
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  getOpthometristList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_OPTOMETRIST_LIST + `?only_available=true`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              OpthometristList: response.data.data,
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  getInsuranceList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              InsuranceList: response.data.data,
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }


  getLastVisitDateOutstandingAmount = (AppointId) => {
    try {
      let APIURL = ""
      if (AppointId) {
        APIURL = "?patient_id=" + this.state.SelectedPatientID + "&module=" + "OP" + "&branch_id=" + localGetItem("BranchId") + "&appointment_id=" + AppointId
      } else {
        APIURL = "?patient_id=" + this.state.SelectedPatientID + "&module=" + "OP" + "&branch_id=" + localGetItem("BranchId")
      }
      RestAPIService.getAll(Serviceurls.FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT + APIURL)
        .then((response) => {
          if (response.data.status === "success") {
              let Date = response.data?.last_visited_date ? response.data.last_visited_date : ""
              let Amount = response.data?.total_outstanding ? response.data.total_outstanding : 0
              let AdvanceBalance = response.data?.advance_balance ? response.data.advance_balance : 0
              let Obj = {"last_visited_date" : Date, "total_outstanding" : Amount, advance_balance : AdvanceBalance}
              if(this.props?.isForOPUpdate){
                this.setState({ PrevBalAmountObj : Obj})
              }else{
                this.props.VisitDateBalAmount(Obj)
              }
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (e) {
      this.errorMessage(e.message)
    }
  }

  assignDemographicsData(Datas) {
    try {
      if (Datas["referral_source"]) {
        this.setState({ refferalValue: Datas?.referral_source, refferedType: "Source" })
      } if (Datas["reffered_by"]) {
        this.setState({ refferalValue: Datas?.reffered_by, refferedType: "Doctor" })
      } if (Datas["referral_staff"]) {
        this.setState({ refferalValue: Datas?.referral_staff, refferedType: "Staff" })
      }
      this.setState({
        mobile_no: Datas.mobile_number,
        first_name: Datas.first_name,
        age: this.handleAgeCalculation(Datas.dob !== null ? new Date(Datas?.dob) : new Date(Datas?.approx_dob)),
        dob: Datas.dob !== null ? new Date(Datas?.dob) : new Date(Datas?.approx_dob),
        gender: Datas.gender,
        title: Datas.title,
        middle_name: Datas.middle_name,
        surname: Datas.last_name,
        address_1: Datas.address_line_1,
        address_2: Datas.address_line_2,
        country_code: this.state.AllCountry.find((item)=>(item.name === Datas?.country))?.isoCode,
        AllStates: State.getStatesOfCountry(this.state.AllCountry.find((item)=>(item.name === Datas?.country))?.isoCode),
        state_code: State.getStatesOfCountry(this.state.AllCountry.find((item)=>(item.name === Datas?.country))?.isoCode).find((item)=>(item.name === Datas?.state_name))?.isoCode,
        city: Datas?.city_name,
        district: Datas?.district,
        pin_code: Datas.pincode,
        employer_id: Datas.employer_id,
        employee_id: Datas.id_no,
        email_id: Datas.email,
        marital_status: Datas.marital_status,
        father_husband_name: Datas.father_husband_name,
        father_husband_age: Datas.father_husband_age ? Datas.father_husband_age : "",
        occupation: Datas.occupation,
        emergency_contact_person: Datas.caretaker_name,
        emergency_contact_mobile: Datas.caretaker_mobile,
        relationship: Datas.caretaker_relationship,
        docDocument: Datas.document_key === "" ? null : Datas.document_key,
        duplicatedDocDocument: Datas.document_key === "" ? null : Datas.document_key,
        aadharProof: Datas.aadhar === "" ? null : Datas.aadhar,
        duplicateAadharProof: Datas.aadhar === "" ? null : Datas.aadhar,
        panProof: Datas.pan === "" ? null : Datas.pan,
        duplicatePanProof: Datas.pan === "" ? null : Datas.pan,
        passportProof: Datas.passport === "" ? null : Datas.passport,
        duplicatePassportProof: Datas.passport === "" ? null : Datas.passport,
        rationProof: Datas.ration_card === "" ? null : Datas.ration_card,
        duplicateRationProof: Datas.ration_card === "" ? null : Datas.ration_card,
        dlProof: Datas.dl === "" ? null : Datas.dl,
        duplicateDlProof: Datas.dl === "" ? null : Datas.dl,
        pancard_number: Datas.pancard_number,
        ration_card_number: Datas.ration_card_number,
        dl_number: Datas.dl_number,
        passport_number: Datas.passport_number,
        aadhar_card_number: Datas.aadhar_card_number,
        patient_img: Datas?.photo_url === "" ? null : Datas.photo_url,
        temp_patient_img: Datas?.photo_url === "" ? null : Datas.photo_url,
        receive_email: Datas?.receive_email,
        receive_whatsapp: Datas?.receive_whatsapp,
        receive_sms: Datas?.receive_sms,
        insurance_company_name: Datas?.insurance_company_name,
        policy_number: Datas?.policy_number,
        insurance_id: Datas?.insurance_id,
        guardian: Datas?.guardian,
        createdBy: Datas?.created_by,
        modifiedBy: Datas?.modified_by,
        mother_name: Datas?.mother_name == null ? "" : Datas?.mother_name,
        mother_age: Datas?.mother_age == null ? "" : Datas?.mother_age,
        old_referral_no: Datas?.old_referral_no ? Datas?.old_referral_no : "",
        appointmentId: Datas?.appointment_id ? Datas?.appointment_id : '',
        admissionId : Datas?.ip_admission_id ? Datas?.ip_admission_id : '',
        creditType: Datas?.primary_payment_type ? Datas?.primary_payment_type : '',
        selectedFatHusName:Datas?.relationship_label ? Datas?.relationship_label : '',
        patient_type: Datas?.patient_type ? Datas?.patient_type : null,
        blood_group: Datas?.blood_group ? Datas?.blood_group : '',
        ccn_number: Datas?.ccn_number ? Datas?.ccn_number : '',
        caretaker_id: Datas?.caretaker_id ? Datas?.caretaker_id : '',
        refferalDesc: Datas?.referral_description ? Datas?.referral_description : '',
        abha_health_id: Datas?.abha_health_id ? Datas?.abha_health_id : '',
        rchid: Datas?.rchid ? Datas?.rchid : '',
      }, () => {
        if(this.state.duplicatedDocDocument){
          this.getS3Key(this.state.duplicatedDocDocument, "docDocument" )
        }
        if (this.state.duplicateAadharProof) {
          this.getS3Key(this.state.duplicateAadharProof ,"aadharProof");
        }
        if (this.state.duplicatePanProof) {
          this.getS3Key(this.state.duplicatePanProof , "panProof");
        }
        if (this.state.duplicatePassportProof ) {
          this.getS3Key(this.state.duplicatePassportProof, "passportProof");
        }
        if (this.state.duplicateRationProof ) {
          this.getS3Key(this.state.duplicateRationProof ,"rationProof");
        }
        if (this.state.duplicateDlProof) {
          this.getS3Key(this.state.duplicateDlProof, "dlProof");
        }
        this.setState({cityName: City.getCitiesOfState(this.state.country_code , this.state.state_code)})
        if (this.props?.OpCreate) {
          this.getLastVisitDateOutstandingAmount()
        } else if (this.props?.isForOPUpdate) {
          let patientDetails = getCachevalue("patientData")
          let patients = JSON.parse(patientDetails)
          let appointment_id = patients?.appointment_id ? patients?.appointment_id : Datas?.appointment_id ? Datas?.appointment_id : ''
          this.setState({appointmentId: appointment_id})
          this.getLastVisitDateOutstandingAmount(patients?.appointment_id)
        }
        this.LoaderFunction(false)
      })
    }
    catch (e) {
      this.LoaderFunction(false)
      this.errorMessage(e?.message)
    }
  }

  _getTagDetails = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPPATIENTTAG)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              tagDetails: response.data.data,
            });
          }
        })
        .catch(error => {

        });
    } catch (e) {
    }
  }

  _getDoctorDetails = () => {
    try {
      var date = new Date(this.state.appointmentDateTime)

      var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
      var appointment_time = DateTime.fromJSDate(date).toFormat('HH:mm')
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?date=${appointment_date}&time=${appointment_time}` )
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              doctorList: response.data.data.filter((item) => (item.specialization_active === true)),
            }, () => {
              if (Object.keys(this.state.RequestedPatientData).length > 0) {
                let DocID = this.state.doctorList.find(item => item.doctor_id === this.state.RequestedPatientData?.doctor_id)
                let SpecID = this.state.spcInfo.find(item => item.id === DocID?.specialization_id)
                this.setState({
                  selectedDocId: DocID ? DocID : null,
                  selectedSpecId: SpecID ? SpecID : null,
                }, () => {
                  if (DocID) {
                    let states = this.state
                    let docDetail = DocID
                    let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === docDetail["specialization_id"])
                    states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
                    this.setState({ states })
                  }
                })
              }else{
                let states = this.state
                if(this.state.selectedSpecId){
                  let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === this.state.selectedSpecId["id"])
                    states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
                    this.setState({ states })
                }
              }

            });
          }
        })
        .catch(error => {

        });
    } catch (e) {
    }
  }
  _getCorpList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              CorporateList: response.data.data,
            });
          }
        })
        .catch(error => {

        });
    } catch (e) {
    }
  }

  _getSpecInfo = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              spcInfo: response.data.data.filter((item) => (item.is_active === true)),
            }, () => {
              if (Object.keys(this.state.RequestedPatientData).length > 0) {
                let DocID = this.state.doctorList.find(item => item.doctor_id === this.state.RequestedPatientData?.doctor_id)
                let SpecID = this.state.spcInfo.find(item => item.id === DocID?.specialization_id)
                this.setState({
                  selectedDocId: DocID ? DocID : null,
                  selectedSpecId: SpecID ? SpecID : null,
                }, () => {
                  if (DocID) {
                    let states = this.state
                    let docDetail = DocID
                    let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === docDetail["specialization_id"])
                    states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
                    this.setState({ states })
                  }
                })
              }
            });
          }
        })
        .catch(error => {

        });
    } catch (e) {
    }
  }
  _getAppointTypeList = () => {
    RestAPIService.getAll(Serviceurls.FO_CONFIG_OPAPPOINTMENT)
      .then(response => {
        if (response.data.status === "success") {
          this.setState({
            AppointmentTypeList: response.data.data.filter((item) => (item.is_active === true)),
          }, () => {
            if ((Object.keys(this.state.RequestedPatientData).length > 0) && !this.props.history?.location?.state?.fromFollowUp) {
              this.setState({
                selectedAppointTypeId: this.state.RequestedPatientData?.booked_through === "Mobile" ? response.data.data.find((item) => (item.appoinment_type === "Mobile Appointment" && item.is_active === true)) : response.data.data.find((item) => (item.appoinment_type === "Telephonic Appointment"))
              })
            } else {
              this.setState({
                selectedAppointTypeId: response.data.data.find((item) => (item.appoinment_type === "Walk in Appointment" && item.is_active === true))
              })
            }
          });
        }
      })
      .catch(error => {

      });
  }

  getDemoLayout = () => {
    try {
      this.LoaderFunction(true)
      RestAPIService.getAll(Serviceurls.FODemographicsLayout)
        .then((response) => {
          if (response.data.status === "success") {
            var Data = response.data.data
            var len = Data.length
            this.setState({
              layoutData: Data[len - 1] ? Data[len - 1].field_order : Demo_Layout_Default_JSON,
              mandotory_count: Data[len - 1] ? ("0" + Data[len - 1].mandatory_field_count) : '04',
            }, () => {
              let MandLabels = []
              for (let i = 0; i < +this.state.mandotory_count; i++) {
                MandLabels.push(this.state.layoutData[i].label)
              }
              this.setState({ MandatoryLabels: MandLabels }, () => { this.LoaderFunction(false) })
            })
          }
        }).catch((error) => {

        })

    } catch (e) {

    }
  }
   
  
      getStaffRefferalData = () => {
          const { t } = this.props
          try {
              this.LoaderFunction(true)
              RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_Config).
                  then((response) => {
                      if (response.data.status === "success") {
                          this.setState({
                              refStaffData: response.data.data
                          },()=>{this.LoaderFunction(false)})
                          
                      }
                  }).catch((error) => {
                      this.LoaderFunction(false)
                      if (error?.response?.data?.status === "fail") {
                          this.errorMessage(error.response.data.message)
                      } else {
                          this.errorMessage(error.message)
                      }
                  })
          } catch (error) {
              this.LoaderFunction(false)
              this.errorMessage(error.message)
          }
      }

  getReferralDctorData = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_DOCTOR).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              refDoctorData: response.data.data
            })
          }
        }).catch((error) => {

        })
    } catch (error) {

    }
  }

  getRefSourceData = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_REF_SOURCE).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              refSourceData: response.data.data
            })
          }
        }).catch((error) => {

        })

    } catch (error) {
    }
  }

  GetCorporateList() {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              CorporateList: response.data.data
            })
          }
          else {
          }
        }).catch((error) => {
        })
    }
    catch (e) {
    }
  }

  getQmsConfig = () => {
    try {
      RestAPIService.getAll(Serviceurls.QMS_CONFIG)
          .then(response => {
              if (response?.data?.status === "success") {
                let data = response?.data?.data
                  this.setState({ 
                    dateLimit: data?.appointment_date_limit ? data?.appointment_date_limit : 90,
                    dateLimitType: data?.duration_type ? data?.duration_type : 'Days',
                  })
              }
          })
          .catch(error => {
              if (error?.response?.data?.status === "fail") {
                  this.errorMessage(error.response.data.message);
              } else {
                  this.errorMessage(error?.message)
              }
          });
  } catch (e) {
      this.errorMessage(e.message);
  }
  }

  CheckExistingPatients() {
    try {
      RestAPIService.getAll(Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.mobile_no}&address_key=&father_husband_key=`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              SameMobileNumPatients: response.data.data
            })
          }
          else {
          }
        }).catch((error) => {
        })
    }
    catch (e) {
    }
  }

  getFutureAppointmentData()  {
    try{
      let userData = JSON.parse(localGetItem("loggedInUserInfo"))
      let patient = this.state.SelectedPatientID 
      let clinic = userData?.clinic_id
      RestAPIService.getAll(Serviceurls.FO_FUTURE_APPOINTMENTS + `?patient_id=${patient}&clinic_id=${clinic}`).
      then((response) => {
        if(response.data.status === "success"){
          this.setState({
            futureAppointments:response.data.data,
            hasFutureAppointment: response?.data?.data?.length > 0
          })
        }
      }).catch(error =>{
          if (error?.response?.data?.status === "fail") {
              this.errorMessage(error.response.data.message);
          } else {
              this.errorMessage(error?.message)
          }
      })
    }catch(e){
      this.errorMessage(e.message);
    }
  }

  getValidUptoData() {
    try{
      let patient = this.state.SelectedPatientID  
      let userData = JSON.parse(localGetItem("loggedInUserInfo"))

      const date = new Date(this.state.appointmentDateTime);
      const appointment_date = DateTime.fromJSDate(date).toFormat("yyyy-MM-dd");
      let queryParams = `?patient_id=${patient}&appointment_date=${appointment_date}`;
    
      if (userData?.review_period_based_on === 'doctor') {
        let doctor_id = this.state.selectedDocId?.doctor_id;
        if (doctor_id) {
          queryParams += `&doctor_id=${doctor_id}`;
        }
      }
      else if (userData?.review_period_based_on === 'specialization') {
        let specialization_id = this.state.selectedSpecId?.id;
        if (specialization_id) {
          queryParams += `&specialization_id=${specialization_id}`;
        }
      }
      RestAPIService.getAll(Serviceurls.FO_SERVICE_VALID_UPTO + queryParams).
      then((response) => {
        if(response.data.status === "success"){
           this.setState({
            hasValiuptoDate:response.data.data,
            hasValid: response?.data?.data ? true : false
          })
        }
      }).catch(error =>{
         if (error?.response?.data?.status === "fail") {
              this.errorMessage(error.response.data.message);
          } else {
              this.errorMessage(error?.message)
          }
      })
    }catch(e){
      this.errorMessage(e.message);
    }
  }

  toggleIdCameraButton = (key) => {
    this.setState({
      isFrontCamera: !this.state.isFrontCamera,
      [key]: null
    }, () => { this.videoConstraints() })
  }

  OpenWebCamIdPopUP = () => {
    const { slcIdKey } = this.state;
    const key = slcIdKey?.replace("Img", "");
    try {
      return (
        <Box>
          <Modal open={true}>
            <Box className="eMed_WebCamPop_Main">
              <Box component={'div'} className="eMed_WebCam_Header">
                <Typography variant='h6'>{"Capture Image"}</Typography>
                <Button onClick={() => {
                  this.setState((prevState) => ({
                    [slcIdKey]: prevState[slcIdKey + "Cap"],
                    imgCapClked: false
                  }))
                }} >
                  <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </Button>
              </Box>
              <Box component={'div'}>
                {
                  this.state[slcIdKey] === null ?
                    <Webcam
                      className='eMed_WebCam_Div'
                      audio={false}
                      mirrored={this.state.isFrontCamera}
                      ref={this.webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={this.videoConstraints()}
                    /> :
                    <img className='eMed_WebCam_Img_Div' src={this.state[slcIdKey]} />
                }
              </Box>
              <Box component={'div'} className="eMed_WebCam_Btn_div" width={"70%"} mr={"3vw"} ml={"7vw"}>
                <Button disabled={this.state[slcIdKey] !== null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ [slcIdKey]: this.webcamRef.current.getScreenshot() }) }}>Capture</Button>
                <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ [slcIdKey]: null }) }}>Retake</Button>
                <Button disabled={this.state[slcIdKey] === null} variant='contained' size='small' id="eMed_Config_btn"
                  onClick={() => {
                    this.setState((prevState) => ({
                      [slcIdKey + "Cap"]: prevState[slcIdKey],
                      [key] : null,
                      imgCapClked: false
                    }))
                  }}>Add Image</Button>
                {this.state.devices?.length > 1 && <Button variant='contained' size='small' id="eMed_Config_btn" sx={{ width: '10.5vw' }} onClick={() => { this.toggleIdCameraButton() }} >
                  Switch to {this.state.isFrontCamera ? "Back" : "Front"} Camera
                </Button>}
              </Box>
            </Box>
          </Modal>
        </Box>
      );
    } catch (e) { }
  };

  alphaValidation = (num) => {
    return !/[^A-Z a-z]+/.test(num)
  }
  numberValidation(num) {
    return /^\d+$/.test(num);
  }
  handleDoctorToken() {
    this.setState({ isRefreshing: true });
    try {
      const date = new Date(this.state.appointmentDateTime);
      const appointment_date = DateTime.fromJSDate(date).toFormat("yyyy-MM-dd");

      const apiCall = RestAPIService.getAll(
        Serviceurls.DOCTOR_TOKEN_NUMBER +
        `?clinic_id=${this.state.clinic_id}&doctor_id=${this.state.selectedDocId?.doctor_id}&appointment_date=${appointment_date}`
      )
      const startTime = Date.now();
      apiCall
        .then((response) => {
          if (response.data.status === "success") {
            if (response.data?.token_number == null) {
              this.errorMessage("No token available for this doctor");
            }

            this.setState({
              doctorToken: response.data?.token_number ?? "-",
            });
          }
        })
        .catch((error) => {
          this.errorMessage(error?.response?.data?.message || "Error");
        })
        .finally(() => {
          const timeSpent = Date.now() - startTime;
          const minDelay = 1000;
          const remaining = Math.max(0, minDelay - timeSpent);

          setTimeout(() => {
            this.setState({ isRefreshing: false });
          }, remaining);
        });

    } catch (e) {
      this.setState({ isRefreshing: false });
    }
  }

  handleAgeCalculation = date => {
    // let age = "";
    // let dob = DateTime.fromJSDate(date);
    // var year_age = DateTime.now().diff(dob, 'years');
    // age = Math.floor(year_age.years) || 0;
    // return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
    let age = "";
    let dob = new Date(date);
    let m = moment(dob, "DD-MM-YYYY");
    var end_date = moment();

    var year_age = end_date.diff(m, 'year') || 0;
    // reset(year) year with difference year
    m = moment(m).add(year_age, 'years');

    var month_age = end_date.diff(m, 'month') || 0;
    // reset(month) month with difference month
    m = moment(m).add(month_age, 'months');

    var day_age = end_date.diff(m, 'days') || 0;

    if (year_age > 0) {
      age = year_age || 0;
    } else {
      age = year_age + "Y/" + month_age + "M/" + day_age + "D";
    }
    return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
  }

  handleFindApproxDob = ageEntered => {

    var year = 0;
    var month = 0;
    var days = 0;
    var tempDate;
    year = +(ageEntered)
    if (!year) {
      tempDate = null;
    } else {
      tempDate = DateTime.now().minus({ years: year }).toBSON();
    }

    return tempDate;
  }
  getPincodeToCity = (pincode) => {
    fetch("https://api.postalpincode.in/pincode/" + pincode)
      .then((res) => res.json())
      .then(response => {
        if (response && response[0].Status == "Success") {
          var data = response[0].PostOffice
          if (data && data.length > 0) {
            var Api_state = (data[0]?.State) == 'Pondicherry' ? 'Puducherry' : (data[0]?.State)
            this.setState({
              city: this.state?.city ? this.state?.city : data[0].District,
              AllStates: this.state?.state_code ? this.state?.AllStates : State.getStatesOfCountry(this.state.AllCountry.find((item)=>(item.name === data[0].Country))?.isoCode),
              country_code: this.state?.country_code ? this.state?.country_code : this.state.AllCountry.find((item)=>(item.name === data[0].Country))?.isoCode,
            },()=>{
              this.setState({
                state_code: this.state?.state_code ? this.state?.state_code : this.state.AllStates.find((item)=>(item.name === Api_state ))?.isoCode,
                cityName: this.state?.city ? this.state?.cityName : City.getCitiesOfState(this.state.country_code, this.state.AllStates.find((item)=>(item.name === Api_state))?.isoCode)
              })
            })
          }
        } else if (response.data.status == "fail") {
        }
      })
      .catch(e => {
      });
  }
  renderInput = (data, type) => {
    var states = this.state
    const { t } = this.props
    var AbhaDisable = (states.SelectedPatientID && (this.props.history?.location?.state?.abha_health_id || this.state.abha_health_id) && this.state.hasAbha) ? true : false
    return (
      <form>
        <Box sx={{ marginTop: '2.5vh', marginLeft: '1vw', width: (data.label == "Age" || data.label == "Title") ? '7vw' : '12vw' }}>
          {data.label == "Date of Birth" ?
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                disabled={(this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)) || AbhaDisable}
                label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                inputFormat={"dd-MM-yyyy"}
                autoComplete="off"
                value={states[data.field_name]}
                minDate={new Date("1872-01-01")}
                maxDate={DateTime.now()}
                onChange={(newDate) => {
                  var age = this.handleAgeCalculation(newDate)
                  this.setState({
                    dob: newDate,
                    age: age
                  })
                }}
                renderInput={(params) => <TextField {...params} size='small' autoComplete="off"
                  variant="outlined" fullWidth />}
              />
            </LocalizationProvider>
            :
            data.label == "Title" ?
              <FormControl size='small' fullWidth sx={{ textAlign: 'center', height: '1.3vw' }}>
                <InputLabel id="title-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                <Select
                  disabled={this.state.SelectedPatientID && ((!(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)) || this.state.disableNameGenderEdit)}
                  labelId="title-select-label"
                  MenuProps={{ style: { maxHeight: 250 } }}
                  size='small'
                  sx={{ fontSize: '0.8vw', }}
                  value={states[data.field_name]}
                  label={t(data.label)}
                  onChange={(e) => {
                    states[data.field_name] = e.target.value

                    this.setState({
                      states
                    }, () => {
                      var states = this.state
                      if (states.title == "Mr") {
                        states["gender"] = "m";
                      } else if (states.title == "Ms") {
                        states["gender"] = "f";
                      } else if (states.title == "Mrs") {
                        states["gender"] = "f";
                        states["marital_status"] = "Married"
                        states["manuallyChanged"] = true
                      } 
                      if(states.manuallyChanged && states.title !== "Mrs") {
                        states["marital_status"] = ""
                      }
                      this.setState({ states })
                    })
                  }}
                >
                  <MenuItem value={""}>{"Title"}</MenuItem>
                  <MenuItem value={"Dr"}>{"Dr"}</MenuItem>
                  <MenuItem value={"Mr"}>{"Mr"}</MenuItem>
                  <MenuItem value={"Ms"}>{"Ms"}</MenuItem>
                  <MenuItem value={"Mrs"}>{"Mrs"}</MenuItem>
                  <MenuItem value={"Master"}>{"Master"}</MenuItem>
                  <MenuItem value={"Baby"}>{"Baby"}</MenuItem>
                  <MenuItem value={"Baby of"}>{"Baby of"}</MenuItem>
                  <MenuItem value={"Child"}>{"Child"}</MenuItem>
                </Select>
              </FormControl>
              : data.label == "Gender" ?
                <FormControl size='small' sx={{ width: '10vw' }}>
                  <InputLabel id="gender-select-label">{"Gender *"}</InputLabel>
                  <Select
                    disabled={(this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)) || (this.state.disableNameGenderEdit && this.state.SelectedPatientID) || AbhaDisable }
                    sx={{ width: '10vw' }}
                    labelId='gender-select-label'
                    size='small'
                    label={t(data.label)}
                    value={states[data.field_name]}
                    onChange={(e) => {
                      states[data.field_name] = e.target.value
                      this.setState({
                        states
                      })
                    }}
                  >
                    <MenuItem key={1} value={"m"}>{t("Male")}</MenuItem>
                    <MenuItem key={2} value={"f"}>{t("Female")}</MenuItem>
                    <MenuItem key={2} value={"t"}>{t("TransGender")}</MenuItem>
                  </Select>
                </FormControl>
                :
                data.label == "Patient Type" ?
                  <FormControl size='small' sx={{ width: '10vw' }}>
                    <InputLabel id="gender-select-label">{"Patient Type"}</InputLabel>
                    <Select
                      sx={{ width: '10vw' }}
                      labelId='patient-type-select-label'
                      size='small'
                      label={t(data.label)}
                      value={states[data?.field_name]}
                      onChange={(e) => {
                        states[data?.field_name] = e.target.value
                        this.setState({
                          states
                        })
                      }}
                    >
                      <MenuItem key={1} disabled={states?.SelectedPatientType === "old_patient" || states?.SelectedPatientType === "review_patient"} value={"new_patient"}>{t("New Patient")}</MenuItem>
                      <MenuItem key={2} disabled={states?.SelectedPatientType === "old_patient"} value={"review_patient"}>{t("Review Patient")}</MenuItem>
                      <MenuItem key={3} value={"old_patient"}>{t("Old Patient")}</MenuItem>
                    </Select>
                  </FormControl>
                  : data.label === "City" ?
                  <Autocomplete 
                    disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                    sx={{ width: "12vw" }}
                    size="small"
                    options={states.cityName ? states.cityName : [] }
                    getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                    onChange={(e, value) => {
                      this.setState({
                        city: value?.name ? value?.name : '',
                        // pin_code: '',
                      })
                    }}
                    clearIcon={false}
                    value={states.city}
                    renderInput={(params) => (
                      <TextField 
                        label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                        InputProps={{ ...params.InputProps }} 
                        onChange={(e) => this.setState({
                          city: e.target.value,
                          // pin_code: ''
                        })}                        {...params}
                        />)}
                      onKeyDown={(e)=>e.key === "Enter" ? e.preventDefault(): null}
                   />
                : data.label === "Insurance Company Name" ?
                  <Autocomplete
                    disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                    sx={{ width: "12vw" }}
                    size="small"
                    options={states.InsuranceList}
                    getOptionLabel={(option) => (typeof (option) === "string" ? option : option.insurance_name)}
                    onChange={(event, value) => {
                      states["insurance_company_name"] = value?.insurance_name ? value?.insurance_name : ""
                      states["NewInsurance"] = false
                      states["insurance_id"] = value?.insurance_id ? value?.insurance_id : ""
                      this.setState({
                        states
                      })
                    }}
                    clearIcon={false}
                    value={states.insurance_company_name}
                    renderInput={(params) => (
                      <TextField
                        label={states?.selectCreditType === 'Insurance credit' ? t("Insurance Company Name *") : t("Insurance Company Name")} InputProps={{ ...params.InputProps }}
                        // onChange={(event) => {
                        //   states["insurance_company_name"] = event.target.value
                        //   states["NewInsurance"] = true
                        //   this.setState({
                        //     states
                        //   })
                        // }}
                        {...params}
                      />
                    )}
            />
                : data.label == "Mobile no" ?
                  <TextField
                    disabled={Object.keys(this.state.RequestedPatientData).length > 0 || this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess) || (this.state.disableNameGenderEdit && this.state.SelectedPatientID)}
                    label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                    autoComplete="off"
                    size="small"
                    onKeyDown={(e) => e.key === 'Enter' &&  e.preventDefault()}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">{"+91"}</InputAdornment>
                    }}
                    value={states[data.field_name]}
                    onChange={(e) => {
                      var states = this.state
                      var isMobile = this.numberValidation(e.target.value)
                      if (data.label == "Mobile no") {
                        let mobileNum = e.target.value
                        if ((isMobile && mobileNum.length < 11) || e.target.value == "") {
                          states[data.field_name] = e.target.value
                          if (e.target.value.length === 10) { this.CheckExistingPatients() }
                        }
                      }
                      this.setState({ states })
                    }}
                    error={states.mobile_no !== "" && states.mobile_no.length !== 10}
                  />
                  : data.label == "Corporate Name" ?
                    <FormControl size='small' sx={{ width: '12vw' }}>
                      <InputLabel id="gender-select-label">{((type === 'mandatory' || data.is_default) || states?.selectCreditType === 'Corporate credit') ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                      <Select
                        disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                        sx={{ width: '12vw' }}
                        MenuProps={{ style: { maxHeight: 250 } }}
                        labelId='gender-select-label'
                        size='small'
                        label={((type === 'mandatory' || data.is_default) || states?.selectCreditType === 'Corporate credit') ? (t(data.label) + "*") : t(data.label)}
                        value={states[data.field_name]}
                        onChange={(e) => {
                          states[data.field_name] = e.target.value
                          if (e.target.value === "") { states.employee_id = "" }
                          this.setState({
                            states
                          })
                        }}
                      >
                        <MenuItem value={""}>{"None"}</MenuItem>
                        {
                          states.CorporateList.length > 0 ?
                            states.CorporateList.map((list, index) => (
                              <MenuItem key={index} value={list.id}>{list.company_name}</MenuItem>
                            )) : null
                        }
                      </Select>
                    </FormControl>
                    : data.label == "Marital Status" ?
                      <FormControl size='small' sx={{ width: '12vw' }}>
                        <InputLabel id="gender-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                        <Select
                          disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                          sx={{ width: '12vw' }}
                          labelId='gender-select-label'
                          size='small'
                          label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                          value={states[data.field_name]}
                          onChange={(e) => {
                            states[data.field_name] = e.target.value
                            states["manuallyChanged"] = false
                            this.setState({
                              states
                            })
                          }}
                        >
                          <MenuItem key={1} value={"Single"}>{t("Single")}</MenuItem>
                          <MenuItem key={2} value={"Married"}>{t("Married")}</MenuItem>
                          <MenuItem key={2} value={"Divorced"}>{t("Divorced")}</MenuItem>
                        </Select>
                      </FormControl>
                      : data.label == "Employee ID No" ?
                        <TextField
                          autoComplete="off"
                          inputProps={{ maxLength: 20 }}
                          label={(type === 'mandatory' || data.is_default || states.employer_id) ? (t(data.label) + "*") : t(data.label)}
                          size="small" value={states[data.field_name]}
                          onKeyDown={(e) => e.key === 'Enter' &&  e.preventDefault()}
                          onChange={(e) => {
                            states[data.field_name] = e.target.value.toUpperCase()
                            this.setState({ states })
                          }}
                          disabled={states.employer_id === null || states.employer_id === "" || this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                        />
                        : data.label == "State" ?
                          // <RegionDropdown className='eMed_demo_dropdown_inputs'
                          //   country={this.state.country}
                          //   value={this.state.state}
                          //   onChange={(val) => {
                          //     states[data.field_name] = val
                          //     this.setState({ states })
                          //   }} />
                            <FormControl size='small' sx={{ width: '12vw' }}>
                              <InputLabel id="title-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                              <Select
                                disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                                sx={{ width: '12vw' }}
                                MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' }}}
                                labelId='gender-select-label'
                                size='small'
                                label={data.label}
                                value={states.state_code}
                                onChange={(e) => {
                                  this.setState({state_code: e.target.value},
                                    ()=>{
                                    this.setState({cityName: City.getCitiesOfState(this.state.country_code, this.state.state_code),city:''})
                                  })
                                }}
                              >
                                {
                                  states.AllStates.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                  ))
                                }
                              </Select>
                            </FormControl>
                          : data.label == "Country" ?
                            <FormControl size='small' sx={{ width: '12vw',maxWidth: '12vw' }}>
                              <InputLabel id="title-select-label">{(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}</InputLabel>
                              <Select
                                disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                                sx={{ width: '12vw' }}
                                MenuProps={{ style: { maxHeight: 250,maxWidth: '12vw' } }}
                                labelId='gender-select-label'
                                label={data.label}
                                size='small'
                                value={states.country_code}
                                onChange={(e) => {
                                  this.setState({country_code: e.target.value, state_code: "",city:''},()=>{
                                    this.setState({AllStates: State.getStatesOfCountry(this.state.country_code),cityName:''})
                                  })
                                }}
                              >
                                {
                                  states.AllCountry.map((list) => (
                                    <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                                  ))
                                }
                              </Select>
                            </FormControl>
                            // <CountryDropdown className='eMed_demo_dropdown_inputs'
                            //   value={this.state.country}
                            //   onChange={(val) => this.setState({ country: val })}
                            //   priorityOptions={["IN"]}
                            //   whitelist={["IN", "AF", "AU", "BT", "CA", "CU", "FR", "DE", "ID", "IR", "JP", "KZ", "MY", "MV", "MN", "PK", "RU", "SA", "SG", "LK", "TW", "TH", "TR", "AE", "GB", "US"]}
                            // />
                                : data.label === "Father/Spouse Name" ?
                                  <Box component={'div'} display={'flex'}>
                                    <Select
                                      size='small'
                                      value={this.state.selectedFatHusName}
                                      onChange={(e) => this.setState({ selectedFatHusName: e.target.value })}
                                      sx={{width:'3.5vw'}}
                                    >
                                      <MenuItem value={1}>Father</MenuItem>
                                      <MenuItem value={2}>Spouse</MenuItem>
                                    </Select>
                                    <TextField
                                      disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                                      label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                      autoComplete="off"
                                      size="small"
                                      inputProps={{maxLength:32}}
                                      onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                                      value={states[data.field_name]}
                                      onChange={(e) => {
                                        let states = this.state
                                        let isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)
                                        if (isSpecial || e.target.value == "") {
                                          states[data.field_name] = e.target.value
                                          this.setState({states })
                                        }
                                      }}
                                      sx={{width:'10vw'}}
                                    />
                                  </Box> : data.label === "RCH ID" ? 
                                      <TextField
                                        size="small"
                                        label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)}
                                        inputProps={{
                                          maxLength: 13,
                                          pattern: "^[0-9-]*$",
                                        }}
                                        value={this.state.rchid || ""}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          const numericHyphenOnly = /^[0-9-]*$/.test(value);
                                          let rchError = false;

                                          if (!numericHyphenOnly) return;

                                          const digitsOnly = value.replace(/-/g, "");
                                          const hyphenCount = (value.match(/-/g) || []).length;

                                          if (hyphenCount > 1) return;

                                          if (digitsOnly.length > 12) return;

                                          if (value !== "") {
                                            rchError = digitsOnly.length !== 12;
                                          }

                                          this.setState({
                                            rchid: value,
                                            rchError,
                                          });
                                        }}
                                        error={this.state.rchError}
                                        // helperText={
                                        //   this.state.rchError
                                        //     ? "Invalid RCH ID. Must have exactly 12 digits and only one hyphen allowed"
                                        //     : ""
                                        // }
                                        // sx={{ width: "12vw", marginTop: "2.5vh", marginLeft: "1vw" }}
                                      />

                                      :
                                  data.label == "Blood Group" ?
                                    <Autocomplete
                                      clearIcon
                                      size='small'
                                      sx={{ width: '12vw' }}
                                      options={this.state.medicalBloodGroup?.map((item) => item.label)}
                                      value={states[data.field_name]}
                                      autoComplete='off'
                                      onChange={(event, newValue) => {
                                        states[data.field_name] = newValue
                                          this.setState({states })
                                      }}
                                      renderInput={(params) => <TextField {...params} label={(type === 'mandatory' || data.is_default) ? (t(data.label) + "*") : t(data.label)} />}
                                    />
                                    :
                            <TextField
                              disabled={((data.label === "First Name") ? (Object.keys(this.state.RequestedPatientData)?.length > 0 || (this.state.disableNameGenderEdit && this.state.SelectedPatientID) || AbhaDisable) : false) || ((data.label === "Middle Name" || data.label === "Surname") ? ((this.state.disableNameGenderEdit && this.state.SelectedPatientID) || AbhaDisable) : false) || (this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)) || ((data.label === "CCN Number" || data.label === "Insurance No") ? !states?.insurance_company_name : false) || ((data.label === "Age") ? AbhaDisable : false)}
                              autoComplete="off"
                              inputProps={{ maxLength: (data.label === "First Name" || data.label === "Middle Name" || data.label === "Surname" || data.label === "Referred By" || data.label === "Referral Source" || data.label === "Mother's Name" || data.label === "Father/Spouse Name" || data.label === "Emergency Contact Person" || data.label === "Relationship" || data.label === "District") ? 32 : ( data.label === "Occupation" || data.label === "'Insurance Company Name'" || data.label === "Insurance No") ? 45 : ( data.label === "Email ID") ? 50 : 100 }}
                              label={(type === 'mandatory' || data.is_default || (states?.insurance_company_name && data.label === "Insurance No")) ? (t(data.label) + "*") : t(data.label)}
                              variant="outlined"
                              value={states[data.field_name]}
                              onKeyDown={(e) => e.key === 'Enter' &&  e.preventDefault()}
                              onChange={(e) => {
                                var isAlpha = this.alphaValidation(e.target.value)
                                var isNum = this.numberValidation(e.target.value)
                                var isAlphaNum = CommonValidation.alphanumValidation(e.target.value)
                                var isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)


                                if (data.label === "Age" || data.label === "Father/Spouse Age" || data.label === "Mother's Age") {
                                  var age = e.target.value
                                  if ((isNum && +(age) <= 150 && +age !== 0) || e.target.value == "") {
                                    states[data.field_name] = e.target.value
                                    states['dob'] = data.label === "Age" ? null : states.dob
                                    this.setState({
                                      states,
                                    }, () => {
                                      if (data.label === "Age") {
                                        var approxDob = this.handleFindApproxDob(this.state.age);
                                        this.setState({
                                          dob: approxDob
                                        })
                                      }
                                    })
                                  }
                                  else if (e.target.value.includes("/")) {
                                    this.setState({ age: "", dob: null })
                                  }
                                }
                                else if (data.label === "First Name" || data.label === "Middle Name" || data.label === "Surname" || data.label === "Emergency Contact Person" || data.label === "Occupation" || data.label === "Relationship" || data.label === "Guardian" || data.label === "District") {
                                  if (isAlpha || e.target.value == "") {
                                    states[data.field_name] = e.target.value
                                    this.setState({
                                      states
                                    })
                                  }
                                }
                                else if (data.label === "Father/Spouse Name" || data.label === "Mother's Name") {
                                  if (isSpecial || e.target.value == "") {
                                    states[data.field_name] = e.target.value
                                    this.setState({
                                      states
                                    })
                                  }
                                }
                                else if (data.label === "Pin Code") {
                                  if ((isNum || e.target.value == "") && e.target.value.length <= 6) {
                                    states[data.field_name] = e.target.value
                                    this.setState({
                                      states
                                    }, () => {
                                      if (this.state.pin_code && this.state.pin_code.length === 6) {
                                        this.getPincodeToCity(this.state.pin_code)
                                      }
                                    })
                                  }
                                }
                                else if (data.label === "Emergency Mobile No") {
                                  if ((isNum || e.target.value == "") && e.target.value.length <= 10) {
                                    states[data.field_name] = e.target.value
                                    this.setState({
                                      states
                                    })
                                  }
                                }
                                else if (data.label === "Insurance No") {
                                  if ((isAlphaNum || e.target.value == "")) {
                                    states[data.field_name] = e.target.value
                                    this.setState({
                                      states
                                    })
                                  }
                                }
                                else {
                                  states[data.field_name] = e.target.value
                                  this.setState({
                                    states
                                  })
                                }
                              }}
                              size="small"
                            /> 
          }
        </Box>
      </form>
    )
  }

  getConnectedDevices = () => {
    navigator?.mediaDevices?.enumerateDevices()
      .then(devices => {
        const videoDevices = devices?.filter(device => device.kind === 'videoinput');
        this.setState({
          devices: videoDevices,
        });
      })
      .catch(error => {
        console.error('Error enumerating devices:', error);
      });
  }
  videoConstraints = () => ({
    facingMode: this.state.isFrontCamera ? 'user' : 'environment',
  });

  toggleCameraButton = () => {
    this.setState({
      isFrontCamera: !this.state.isFrontCamera,
      temp_patient_img: null
    }, () => { this.videoConstraints() })
  }

  OpenWebCamPopUP = () => {
    try {
      return (
        <Box>
          <Modal open={true}>
            <Box className="eMed_WebCamPop_Main">
              <Box component={'div'} className="eMed_WebCam_Header">
                <Typography variant='h6'>{"Patient Profile "}</Typography>
                <Button onClick={() => { this.setState({ temp_patient_img: this.state.patient_img, ProfilePicClicked: false }) }} >
                  <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </Button>
              </Box>
              <Box component={'div'}>
                {
                  this.state.temp_patient_img === null ?
                    <Webcam
                      className='eMed_WebCam_Div'
                      audio={false}
                      mirrored={this.state.isFrontCamera}
                      videoConstraints={this.videoConstraints()}  
                      ref={this.webcamRef}
                      screenshotFormat="image/jpeg"
                    /> :
                    <img className='eMed_WebCam_Img_Div' src={this.state.temp_patient_img} />
                }
              </Box>
              <Box component={'div'} className="eMed_WebCam_Btn_div"  width={"70%"} mr={"3vw"} ml={"7vw"}>
                <Button disabled={this.state.temp_patient_img !== null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ temp_patient_img: this.webcamRef.current.getScreenshot() }) }}>Capture</Button>
                <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ temp_patient_img: null }) }}>Retake</Button>
                <Button disabled={this.state.temp_patient_img === null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ patient_img: this.state.temp_patient_img, ProfilePicClicked: false }) }}>Set Profile</Button>
                {this.state.devices?.length > 1 && <Button variant='contained' size='small' id="eMed_Config_btn" sx={{width: '10.5vw'}} onClick={() => { this.toggleCameraButton() }} >
                  Switch to {this.state.isFrontCamera ? "Back" : "Front"} Camera
                </Button>}
              </Box>
            </Box>
          </Modal>
        </Box>
      );
    } catch (e) { }
  };

  convertTime = (timeString) => {
    // Parse the time string
    let [time, meridiem] = timeString.match(/\d+:\d+\s([APMapm]{2})/);
  
    // Convert to 24-hour format if needed
    if (meridiem === 'PM' || meridiem === 'pm') {
      let [hours, minutes] = time.split(':');
      hours = (parseInt(hours, 10) % 12) + 12;
      time = `${hours}:${minutes}`;
    }
  
    // Create a Date object
    let now = new Date();
    let [hours, minutes] = time.split(':');
    let date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
  
    return date;
  }

  onClickChipHandler = (item) => {
    this.setState({ selectedSlot: item })
  }

  convertTo12Hour(time) {
    const [hour, minute] = time.split(':').map(Number);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12; // Converts "0" hour to "12"
    return `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
}
ClosePopUp = () => {
  this.setState({ pdfPreview: false, pdfData: '' })
}

  OpenAppointmentSlotPopUP = () => {
    return (
      <Box>
        <Modal open={true}>
          <Box className="eMed_WebCamPop_Main" sx={{ height: "40vh" }}>
            <Box component={'div'} className="eMed_WebCam_Header">
              <Typography fontWeight={600} fontSize={'1.1vw'} color={Colors.SecondaryText}>
                Select Slot
              </Typography>
              <Button onClick={() => { this.setState({ slotPopup: false }) }} >
                <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
              </Button>
            </Box>
            <Box component={'div'} style={{ display: "flex", flexWrap: "wrap", width: "90%", alignItems: "center", margin: "1vw", marginLeft: "2.5vw", height: "25vh", overflow: "scroll" }}>
              {typeof (this.state.slotList) === 'object' && !Array.isArray(this.state.slotList) ?
                // When slotList is an object (not array)
                Object.entries(this.state.slotList).map(([period, timeSlots]) => (
                  timeSlots.length > 0 && (
                    <div key={period}>
                      <Typography fontSize={'1vw'} fontWeight={'bold'} sx={{ marginBottom: '0.5vw' }}>
                        {`${period} :`}
                      </Typography>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5vw', marginBottom: '1vw' }}>
                        {timeSlots.map((item, index) => (
                          <Chip
                            className='eMed_chip'
                            size="medium"
                            label={this.convertTo12Hour(item)}
                            variant={item === this.state.selectedSlot ? 'contained' : 'outlined'}
                            key={`${period}-${index}`}
                            onClick={() => { this.onClickChipHandler(item) }}
                            color={'primary'}
                            sx={{ width: "5vw", borderRadius: "0.6vw" }}
                            clickable
                          />
                        ))}
                      </div>
                    </div>
                  )
                ))
                :
                // When slotList is an array or empty
                this.state.slotList?.length > 0 ? this.state.slotList.map((item, index) => (
                  <Chip
                    className='eMed_chip'
                    size="medium"
                    label={this.convertTo12Hour(item)}
                    variant={item === this.state.selectedSlot ? 'contained' : 'outlined'}
                    key={index}
                    onClick={() => { this.onClickChipHandler(item) }}
                    color={'primary'}
                    sx={{ width: "5vw", borderRadius: "0.6vw" }}
                    clickable
                  />
                )) :
                  <Typography sx={{ height: "5vw", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "red" }}>
                    {"Doctor Schedule not available"}
                  </Typography>
              }
            </Box>
            <Box component={'div'} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", paddingLeft: "1vw", paddingRight: "3vw" }}>
              <Button variant='outlined' size='small' id="eMed_Config_btn" style={{ marginRight: "0.5vw" }} onClick={() => { this.setState({ selectedSlot: "" }) }}>Clear</Button>
              <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => {
                let AppointTime = new Date(this.state.appointmentDateTime)
                if (this.state.selectedSlot) {
                  AppointTime.setHours(this.state.selectedSlot?.split(":")[0]);
                  AppointTime.setMinutes(this.state.selectedSlot?.split(":")[1]);
                }
                this.setState({
                  appointmentDateTime: (AppointTime && this.state.selectedSlot) ? AppointTime : this.state.appointmentDateTime,
                  slotPopup: false
                })
              }}>Select</Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    )
  }

  PrintOPcard = () => {
    const { t } = this.props
    try {
      var id = this.state.SelectedPatientID
      RestAPIService.getAll(Serviceurls.COMMON_BARCODE_PRINT + "?patient_id=" + id + "&appointment_id=" + this.state.appointmentId + "&admission_id=" + this.state.admissionId).
      then((response) => {
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.setState({ selectedOption: "" })
      }).catch((error) => {
        if (error.response?.data?.message) {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: error.response?.data?.message
          })
        } else {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: error.message
          })
        }
        this.setState({ selectedOption: "" })
      })
    } catch (error) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: t("PrintError")
      })
    }
  }

  dialogPopup() {
    const { DialogFuture, futureAppointments, hasValiuptoDate } = this.state;
    const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))

    return (
      <Dialog open={DialogFuture} maxWidth='sm' fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', padding: '1vw' }}>
          <Typography fontSize={'1rem'} fontWeight={600}>{'Future Appointment'}</Typography>
          <Button onClick={() => { this.setState({ DialogFuture:false}); }}>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: '1vw' }}>
          {hasValiuptoDate?.valid_upto ? (
            <Box
              sx={{
                backgroundColor: '#ffedd5',
                borderLeft: '4px solid #f97316',
                color: 'text.primary',
                p: 1,
                mb: 2,
                mt: 2,
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.875rem'
              }}
            >
              <Typography component="span" sx={{ fontSize: '0.85rem' }}>
                {loginInfo?.review_period_based_on === "doctor"
                  ? `An active follow-up exists for the patient with Dr. ${hasValiuptoDate?.doctor_name}, valid upto ${hasValiuptoDate?.valid_upto ? formatDate(hasValiuptoDate?.valid_upto) : ''}.`
                  : loginInfo?.review_period_based_on === "specialization"
                    ? `An active follow-up exists for the patient under ${hasValiuptoDate?.specialization_name || 'Specialization'}, valid upto ${hasValiuptoDate?.valid_upto ? formatDate(hasValiuptoDate?.valid_upto) : ''}.`
                    : `An active follow-up exists for the patient, valid upto ${hasValiuptoDate?.valid_upto ? formatDate(hasValiuptoDate?.valid_upto) : ''}.`
                }
              </Typography>
            </Box>
          ) : null}
          
          <TableContainer sx={{ maxHeight: '60dvh' }}>
            {futureAppointments.length > 0 ? (
              <Table size='small' stickyHeader sx={{ minWidth: 500 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: '1rem', width: '18%' }}>Date</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: '1rem', width: '32%' }}>Doctor Name</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 500, fontSize: '1rem', width: '34%' }}>Specialization</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {futureAppointments.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.appointment_date ? formatDate(row?.appointment_date) : ''}</TableCell>
                      {row?.doctor_name.length > 20 ? <Tooltip title={row?.doctor_name} placement='top' arrow>
                        <TableCell sx={{ width: '5vw' }} >{row?.doctor_name.slice(0,18) + '...'} </TableCell>
                      </Tooltip>
                       : <TableCell align="center">{row?.doctor_name}</TableCell>}
                      {row?.specialization_name.length > 20 ? (
                        <Tooltip title={row?.specialization_name} placement="top-start" arrow>
                          <TableCell align="center">{row?.specialization_name.slice(0, 25) + '...'}</TableCell>
                        </Tooltip>
                      ) : (
                        <TableCell align="center">{row?.specialization_name}</TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : <Typography>No Records Found</Typography>}
          </TableContainer>
        </DialogContent>
      </Dialog>
    );
  }


  renderCreateAppointmentLeft = () => {
    const { t, fromViewGraphics } = this.props
    const fileExtension =( (this.state.duplicatedDocDocument?.includes(".jpg")) || (this.state.duplicatedDocDocument?.includes(".jpeg")) || (this.state.duplicatedDocDocument?.includes(".png"))) ? true : false
    var states = this.state
    var Mandatory_Array = []
    var Non_Mandatory_Array = []
    const SplitCount = +(states.mandotory_count)
    const Total_Len = (states.layoutData).length

    var Active_Array = (states.layoutData).filter((item) => {
      return item.is_active == true
    })

    Mandatory_Array = (Active_Array).slice(0, SplitCount)
    Non_Mandatory_Array = (Active_Array).slice(SplitCount, Total_Len)
    if((this.props.isForOPUpdate || this.props.fromViewGraphics) && this.state.SelectedPatientID && this.state.PatientTypeConfig){
    const newData = { label: 'Patient Type', field_name: 'patient_type', id: Total_Len+1, is_active: true, is_default: false};
    Non_Mandatory_Array = [...Non_Mandatory_Array, newData];
    }
    const userData = JSON.parse(localGetItem("loggedInUserInfo"))
    return (
      <Box component={"div"} className={fromViewGraphics ? "eMed_createapt_left eMed_ipcreateapt_left" : "eMed_createapt_left"}>
        <Box className="eMed_createapt_left1">
          <Paper className='eMed_createapt_left1_paper1'>
            <Typography className='eMed_refdoc_title'>{t("Referral Information")}</Typography>
            <Box component={'div'} className="eMed_createapt_left1_paper1_box">
              
            <FormControl size='small' sx={{ width: '10vw', marginRight: "1dvw" }}>
                <InputLabel id="referredby-select-label">{"Referred Type"}</InputLabel>
                <Select
                  labelId="referredby-select-label"
                  MenuProps={{ style: { maxHeight: 250 } }}
                  size='small'
                  value={states.refferedType}
                  label={"Referred Type"}
                  disabled={(this.state?.admissionId || this.state.appointmentId) && (this?.state?.allow_referral_field && this.state.isUser)}
                  onChange={(e) => {
                    this.setState({
                      refferedType: e.target.value,
                      refferalValue: ""
                    },()=>{
                      if(this.state.refferedType === "Source"){
                         if(this.state.refSourceData?.length > 0){
                          // this.setState({refferalOpen : true})
                         }else{
                          this.errorMessage("Source data not found")
                         }
                      } else if(this.state.refferedType === "Doctor"){
                        if(this.state.refDoctorData?.length > 0){
                        //  this.setState({refferalOpen : true})
                        }else{
                          this.errorMessage("Doctor data not found")
                        }
                     } else if(this.state.refferedType === "Staff"){
                      if(this.state.refStaffData?.length > 0){
                      //  this.setState({refferalOpen : true})
                      }else{
                        this.errorMessage("Staff data not found")
                      }
                   }
                    }
                  )
                  }}
                >
                  {states.refTypeData?.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}

                </Select>
              </FormControl>

              <FormControl size='small' sx={{ width: '15vw', marginRight: "1dvw" }}>
                <InputLabel id="referredby-select-label">{this.state.refferedType === "Source" ? "Referred Source":this.state.refferedType === "Doctor" ? "Referred Doctor" : this.state.refferedType === "Staff" ? "Referred Staff" : "Referral Detail"}</InputLabel>
                <Select
                  //  open={this.state.openPaper ||this.state.refferalOpen ? true : false }
                  //  onOpen={() => {
                  //      if(this.state.refferalOpen){return true}
                  //      this.setState({ openPaper: true }) }}
                  //  onClose={() => { 
                  //      if(this.state.refferalOpen){return false}
                  //      this.setState({ openPaper: false }) 
                  //  }}
                  // open={this.state.refferalOpen ? true : false}
                  labelId="referredby-select-label"
                  MenuProps={{ style: { maxHeight: 250 } }}
                  size='small'
                  disabled={!this.state?.refferedType || ((this.state?.admissionId || this.state.appointmentId) && (this?.state?.allow_referral_field && this.state.isUser))}
                  value={ states.refferalValue}
                  label={this.state.refferedType === "Source" ? "Referred Source" : this.state.refferedType === "Doctor" ? "Doctor" : this.state.refferedType === "Staff" ? "Referred Staff" : "Referral Detail"}
                  onChange={(e) => {  
                    this.setState({
                      refferalValue: e.target.value,
                      refferalOpen : false
                    })
                  }}
                >
                  {
                   this.state.refferedType === "Doctor" ? states.refDoctorData?.map((item, index) => (
                    <MenuItem value={item.name}>{item.name}</MenuItem>
                  )) : this.state.refferedType === "Source" ? states.refSourceData?.map((item, index) => (
                    <MenuItem value={item.source_name}>{item.source_name}</MenuItem>
                  )) :this.state.refferedType === "Staff" ? states.refStaffData?.map((item, index) => (
                    <MenuItem value={item?.id}>{item?.name}</MenuItem>
                  )) : null
                  }

                </Select>
              </FormControl>
              <FormControl size='small' sx={{ width: '15vw', marginRight: "1dvw"}}>
                  <TextField
                      multiline
                      label='Referral Description'
                      rows={1}
                      disabled={!this.state?.refferedType}
                      value={this.state.refferalDesc}
                      onChange={(e) => {
                          let value = e.target.value
                          if (value?.length < 256) {
                              this.setState({
                                refferalDesc: e.target.value,
                                refferalOpen : false
                              })
                          } else {
                              this.errorMessage('Allowed only 256 characters')
                          }
                      }}
                      sx={{
                          "& .MuiInputBase-root": {
                          height: "5.4dvh", 
                          },
                          "& .MuiInputLabel-root": {
                          top: '-6px', 
                          }
                      }}
                  />
              </FormControl>
              <input
                type="file"
                accept="application/pdf, image/jpg, image/jpeg, image/png"
                onChange={(e) => this.UploadImage(e, "docDocument")}
                ref={this.uploadImage}
                style={{ display: "none" }}
              />
              {
                (this.state.docDocument === null || this.state.docDocument === "delete") ?
                  <Button
                    size='small'
                    variant="contained"
                    onClick={() => this.uploadImage.current.click()}
                  >
                     <FileUploadOutlinedIcon />
                  </Button>
                  :
                  <Box>
                    <div className='emedhub_doc_image_size'>
                      <Tooltip title={typeof (this.state.docDocument) === "string" ? null : this.state.docDocument?.name} arrow placement='top'>
                        <img
                          onClick={() => {
                              if (typeof this.state.docDocument === "string") {
                              if (fileExtension || this.state.docDocument &&  ((typeof(this.state.docDocument) !== "object") && (typeof(this.state.docDocument) !== "string" )) && this.state.docDocument?.startsWith("blob:")) {
                                this.setState({ SelectedDocSRC: this.state.docDocument })  
                              }else if(typeof this.state.docDocument === "string" && this.state.duplicatedDocDocument?.includes(".pdf")) {
                                this.fetchAndConvertToBase64(this.state.docDocument)?.then((base64) => {
                                  base64 = base64?.replace("data:binary/octet-stream;", "data:application/pdf;");
                                  this.setState({ pdfPreview: true, pdfData: base64})                              
                                });                          
                              }
                            }
                          }}
                          src={this.state.docDocument &&  typeof(this.state.docDocument) !== "object" && (this.state.docDocument?.startsWith("blob:") && fileExtension) ? this.state.docDocument : ImagePaths.DocumentPreview.default}
                          className='eMed_createapt_right2_field_img_inv'
                        />
                      </Tooltip>
                      <div>
                        <IconButton onClick={() => {
                          this.state.docDocument = "delete"
                          this.setState({ states })
                        }}
                          size='small'
                          className='emedhub_icon_img_close'
                        ><Close fontSize='small' /></IconButton>
                      </div>
                    </div>
                    {/* <div className='emedhub_doc_image_size'>
                      <img onClick={() => { this.setState({ SelectedDocSRC: this.state.docDocument, refDocumentSelected: true }) }} src={typeof (this.state.docDocument) === "string" ? this.state.docDocument : this.state.docDocument?.type === "application/pdf" ? ImagePaths.Reports.default : this.state.docDocument?.data_url} className='eMed_createapt_right2_field_img_inv' />
                      <div>
                        <IconButton onClick={() => {
                          this.setState({ docDocument: "delete" })
                        }}
                          size='small'
                          className='emedhub_icon_img_close'
                        ><Close fontSize='small' /></IconButton>
                      </div>
                    </div> */}
                  </Box>
              }
            </Box>
          </Paper>
          <Paper className='eMed_createapt_left1_paper2'>
            <IconButton className='eMed_createapt_left1_paper2_icon' onClick={() => { this.setState({ ProfilePicClicked: true },()=>{ this.getConnectedDevices()}) }}>
              <img className='eMed_createapt_left1_paper2_img' src={this.state.patient_img === null ? ImagePaths.UploadPatientDP.default : this.state.patient_img} alt="ProfileImage" />
            </IconButton>
          </Paper>
        </Box>
        <Paper className={fromViewGraphics ? 'eMed_createapt_left2 eMed_ipcreateapt_left2' : 'eMed_createapt_left2'}>
          <Box className='eMed_refdoc_title eMed_Demo_Title'>
            <Typography sx={{ fontWeight: 600 }}>{t("Patient Information")}</Typography>
            {this.props?.isForOPUpdate ?
            <Tooltip title={'Print Barcode'} arrow>
                <img style={{ marginLeft: '0.6vw', width: '1.3vw', height: '1.3vw', cursor: 'pointer' }}
                    src={ImagePaths.PrintIcons.default} alt='' onClick={()=>{this.PrintOPcard()}}/>
            </Tooltip> : null }
            <Box sx={{ width: '32vw' }} display={this.props?.isForOPUpdate ? "flex" : 'none'}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: "0.5vw" }}>
                <Typography fontSize={"0.8vw"}>Previous Credit Balance : </Typography>
                <Typography fontSize={"0.8vw"} fontWeight={600} marginLeft={"0.3vw"}>{`${this.state.PrevBalAmountObj?.total_outstanding ? AmountFormat(this.state.PrevBalAmountObj?.total_outstanding) : AmountFormat(0)}`}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: "1.5vw" }}>
                <Typography fontSize={"0.8vw"}>Previous Advance Balance : </Typography>
                <Typography fontSize={"0.8vw"} fontWeight={600} marginLeft={"0.3vw"}>{`${this.state.PrevBalAmountObj?.advance_balance ? AmountFormat(this.state.PrevBalAmountObj?.advance_balance) : AmountFormat(0)}`}</Typography>
              </Box>
            </Box>
            <Box sx={{ width: '14vw', display:'flex' }}>
              <Box>
                {(((this.state.hasFutureAppointment && this.state.futureAppointments.length > 0) || (this.state.hasValiuptoDate?.valid_upto && this.state.hasValid)) && (!this.props.isFromIP && !this.props.isForOPUpdate && !this.props.fromViewGraphics)) ? 
                <IconButton sx={{ height: '1.5vw', width: '1.5vw', marginRight: '1vw' }} onClick={() => {
                  {
                    this.setState({ DialogFuture: true })
                  }
                }}>
                  <img src={ImagePaths.FutureAppointment.default} alt='help' style={{ height: '1.5vw', width: '1.5vw' }} />
                </IconButton> : null}
              </Box>
                <Box>
                  <Box className='eMed_OP_PatientType'>
                    <Box className='eMed_Demo_Created_Con'>
                      <Typography id='eMed_Demo_Created_Text'>{t('CreatedBy')}</Typography>
                      <Typography id='eMed_Demo_Created_Text'>:</Typography>
                    </Box>
                    <Typography id='eMed_Demo_Created_Text'>{this.state.createdBy ? this.state.createdBy : '-'}</Typography>
                  </Box>
                  <Box className='eMed_OP_PatientType'>
                    <Box className='eMed_Demo_Created_Con'>
                      <Typography id='eMed_Demo_Created_Text'>{t('ModifiedBy')}</Typography>
                      <Typography id='eMed_Demo_Created_Text'>:</Typography>
                    </Box>
                    <Typography id='eMed_Demo_Created_Text'>{this.state.modifiedBy ? this.state.modifiedBy : '-'}</Typography>
                  </Box>
                </Box>
            </Box>
          </Box>


          <Box className="eMed_demolayout_left_TextInput">
            {Mandatory_Array.map((item, index) => (
              this.renderInput(item, 'mandatory')
            ))}
          </Box>
          <Divider />
          <Box className="eMed_demolayout_left_TextInput">
            {Non_Mandatory_Array.map((item, index) => (
              this.renderInput(item, 'non-mandatory')
            ))}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '2vw', paddingTop: '0.3vw'}}>
            {/* <FormControlLabel control={<Checkbox checked={this.state.receive_email} onChange={(e) => { this.setState({ receive_email: e.target.checked }) }} size='small' />} label="Receive Email" /> */}
            <FormControlLabel control={<Checkbox checked={this.state.receive_sms} onChange={(e) => { this.setState({ receive_sms: e.target.checked }) }} size='small' />} label="Receive SMS" />
            {userData?.whatsapp_configuration ? <FormControlLabel control={<Checkbox checked={this.state.receive_whatsapp} onChange={(e) => { this.setState({ receive_whatsapp: e.target.checked }) }} size='small' />} label="WhatsApp" /> : null}
          </Box>
        </Paper>

      </Box>
    )
  }


  renderDropdown = (label, mt, Data = [], stateKey) => {
    var states = this.state
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    const CustomKey=localGetItem("display_latest_token_number") == "true"? true : false
    return (
      <Box sx={{ width: label === "Optometrist" ? "92%" : '45%', mt: mt }}>
        <Autocomplete
          size='small'
          clearIcon={false}
          sx={{ width: label === "Optometrist" ? '27.5vw' : '14vw' }}
          componentsProps={{ popper: { style: { width: label === 'Doctor' ? (this.state.isQmsConfig ? "30vw" : "23vw") : label === "Optometrist" ? "23vw" : "14vw" } } }}
          disabled={this.props?.is_Nurse && label === "Specialization" ? true : false}
          options={Data}
          getOptionLabel={(item) => ((label === "Doctor" ? item.doctor_name : label === "Specialization" ? item.name : label === "Patient Tag" ? item.patient_tag_name : label === "Appointment Type" ? item.appoinment_type : label === "Nurse" ? item.nurse : label === "Optometrist" ? item.name : ""))}
          value={states[stateKey]}
          renderOption={label === 'Doctor' ? (props, item) => (
            <Box>
              {props["data-option-index"] === 0 ?
                <Box className="eMed_App_Doctor_table_head" sx={{ width: this.state.isQmsConfig ? "29vw" : "22vw" }}>
                  <Typography width={this.state.isQmsConfig ? "40%" : "50%"} fontWeight={'600'} fontSize={"0.8vw"}>Doctor Name</Typography>
                  <Typography width={this.state.isQmsConfig ? "15%" : "25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
                  <Typography width={this.state.isQmsConfig ? "15%" : "25%"} fontWeight={'600'} fontSize={"0.8vw"}>New App</Typography>
                  {this.state.isQmsConfig ? <Typography width={"30%"} fontWeight={'600'} fontSize={"0.8vw"} paddingLeft={"0.5vw"}>Availability</Typography> : null}
                </Box> : null}
              <Box component="li" className='eMed_App_Doctor_table_data' {...props} sx={{ width: this.state.isQmsConfig ? "29vw" : '22vw' }}>
                <div style={{ width: this.state.isQmsConfig ? "40%" : "50%" }}>{item?.doctor_name.length > 15 ? <Tooltip placement="top" title={item?.doctor_name} arrow><div>{item?.doctor_name.slice(0, 16) + "..."}</div></Tooltip> : item?.doctor_name ? item?.doctor_name : "-"}</div>
                <Typography width={this.state.isQmsConfig ? "15%" : "25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment}</Typography>
                <Typography width={this.state.isQmsConfig ? "15%" : "25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.new_appointment}</Typography>
                {this.state.isQmsConfig ? <Box width={"30%"} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <Box className="eMed_Unavailable_point" sx={{ backgroundColor: item.availability === "Available" ? "#1E972A" : item.availability === "Inpermission" ? "#DE7D24" : "#B8170D" }}></Box>
                  {item?.reason ? <Tooltip placement='top' title={item?.reason} arrow><div>{item.availability}</div></Tooltip> : <Typography>{item.availability}</Typography>}
                </Box> : null}
              </Box>
            </Box>) :
            label === 'Optometrist' ? (props, item) => (
              <Box>
                {props["data-option-index"] === 0 ?
                  <Box className="eMed_App_Doctor_table_head" sx={{ width: "22vw" }}>
                    <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Optometrist Name</Typography>
                    <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
                    <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Pending App</Typography>
                  </Box> : null}
                <Box component="li" className='eMed_App_Doctor_table_data' {...props} sx={{ width: '22vw' }}>
                  <div style={{ width: "50%" }}>{item?.name?.length > 15 ? <Tooltip placement="top" title={item?.name} arrow><div>{item?.name.slice(0, 16) + "..."}</div></Tooltip> : item?.name ? item?.name : "-"}</div>
                  <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment_count}</Typography>
                  <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.pending_appointment_count}</Typography>
                </Box>
              </Box>
            ) : null}
          onChange={(event, newValue) => {
            states[stateKey] = newValue
            if (newValue !== null && "doctor_id" in newValue) {
              let docDetail = { ...newValue }
              docDetail["name"] = docDetail["specialization_name"];
              delete docDetail.specialization_name;
              docDetail["id"] = docDetail["specialization_id"];
              delete docDetail.specialization_id;
              states["selectedSpecId"] = docDetail;
            }
            if (newValue !== null && "name" in newValue && label !== "Optometrist") {
              let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === newValue["id"])
              states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
              states["selectedDocId"] = null;
            }
            if (newValue === null && label === "Specialization") {
              states["filteredDocList"] = states["doctorList"];
            }
            if (label === "Doctor" || label === "Specialization") {
              if (this.props.OpCreate) {
                let selectedSpec = this.state.spcInfo?.find((item) => item?.id === newValue?.specialization_id)?.purpose_of_visit
                if(!states.manuallySelected || states.purposeOfVisit === ""){
                  states["purposeOfVisit"] = newValue?.purpose_of_visit ? newValue?.purpose_of_visit : selectedSpec ? selectedSpec : (states.selectedSpecId && states.purposeOfVisit) ? states.purposeOfVisit : ''
                }
              }
              states["selectedSlot"] = ""
              states["slotList"] = []
            }
            if(this?.state?.selectedDocId !== null && label === "Doctor" && userData?.module_name === 'front_office' && CustomKey && userData?.token_gen_type=="Doctor"){
              this.setState({ selectedDocId: newValue }, () => {
              this.handleDoctorToken();
            });
            }
            if(label === "Specialization"){
              states['selectedOptometrist'] = null
            }

            this.setState(states, () => {
              const { selectedDocId, selectedSpecId , SelectedPatientID, appointmentDateTime  } = this.state;
              if (
                (userData?.review_period_based_on === 'clinic' ||
                  userData?.review_period_based_on === 'doctor') &&
                selectedDocId && SelectedPatientID
              ) {
                this.getValidUptoData();
              } else if (
                userData?.review_period_based_on === 'specialization' &&
                selectedSpecId && SelectedPatientID
              ) {
                this.getValidUptoData();
              }
            })
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label + `${((label === "Doctor" && this.state.isDoctorMandatory) || label === "Specialization" || label === "Nurse" || label === "Optometrist") ? " *" : ""}`}
              placeholder={label}
            />
          )}
        />
      </Box>
    )
  }

  UploadImage = (e, key, imgKey) => {
    let states = this.state
    states[key] = e.target.files[0]
    states[imgKey] = null
    states[imgKey + "Cap"] = null
    this.setState({ states })
    e.target.value = ''
  }


  renderIdentityProof = (Label, key, NumberKey, duplicatedata, imgKey) => {
    const fileExtension =( (duplicatedata?.includes(".jpg")) || (duplicatedata?.includes(".jpeg")) || (duplicatedata?.includes(".png"))) ? true : false
    let states = this.state;
    const btnDisable = (states[imgKey + "Cap"] || states[key]) && states[key] !== "delete";
    return (
      <Box className="eMed_createapt_right2_box">
        <TextField
          label={Label}
          sx={{ flex: "0 0 18vw" }}
          size="small"
          value={states[NumberKey]}
          onChange={(e) => {
            let value = e.target.value
            if (NumberKey === "aadhar_card_number") {
              let Valid = CommonValidation.numberOnly(value)
              if ((Valid || value === "") && value.length <= 12) {
                states[NumberKey] = value
              }
            }
            else if (NumberKey === "passport_number") {
              let Valid = CommonValidation.ALPHA_NUMARIC(value)
              if ((Valid || value === "") && value.length <= 8) {
                states[NumberKey] = value.toUpperCase()
              }
            }
            else if (NumberKey === "pancard_number") {
              let Valid = CommonValidation.ALPHA_NUMARIC(value)
              if ((Valid || value === "") && value.length <= 10) {
                states[NumberKey] = value.toUpperCase()
              }
            }
            else {
              let Valid = CommonValidation.ALPHA_NUMARIC(value)
              if ((Valid || value === "") && value.length <= 15) {
                states[NumberKey] = value.toUpperCase()
              }
            }
            this.setState({ states })
          }}
        />
        <Box sx={{display: "flex", alignItems: "center", flex: 0.3, gap: "0.1vw"}}>
        <IconButton size='small' component="label" disabled = {btnDisable}>
          <input onChange={(e) => this.UploadImage(e, key, imgKey)} hidden accept="application/pdf, image/jpg, image/jpeg, image/png" type="file" />
          <img className='eMed_createapt_right2_field_img' src={btnDisable ? ImagePaths.UploadBtnThemeOff.default : ImagePaths.UploadBtnTheme.default} alt="" />
        </IconButton>
        <IconButton size='small' component="label" disabled = {btnDisable} onClick={() => { this.setState({ imgCapClked: true, slcIdKey: imgKey },()=>{ this.getConnectedDevices()}) }}>
          <img className='eMed_createapt_right2_field_img' src={btnDisable ? ImagePaths.captureImgOff.default : ImagePaths.captureImg.default} alt="" />
        </IconButton>
        {(states[key] !== null && states[key] !== "delete") ?
          <div className='emedhub_doc_image_size'>
            <Tooltip title={typeof (states[key]) === "string" ? null : states[key]?.name} arrow placement='top'>
              <img
                onClick={() => {
                  if (typeof (states[key]) === "string") {
                    if (fileExtension || states[key] && ((typeof (states[key]) !== "object") && (typeof (states[key]) !== "string")) && states[key]?.startsWith("blob:")) {
                      this.setState({ SelectedDocSRC: states[key] })
                    } else if (typeof states[key] === "string" && duplicatedata?.includes(".pdf")) {
                      this.fetchAndConvertToBase64(states[key])?.then((base64) => {
                        base64 = base64?.replace("data:binary/octet-stream;", "data:application/pdf;");
                        this.setState({ pdfPreview: true, pdfData: base64 })
                      });
                    }
                  }
                }}
                src={states[key] && typeof (states[key]) !== "object" && (states[key]?.startsWith("blob:") && fileExtension) ? states[key] : ImagePaths.DocumentPreview.default}

                className={fileExtension ? 'eMed_createapt_right2_field_capImg' : 'eMed_createapt_right2_field_img_inv'} />
            </Tooltip>
            <div>
              <IconButton onClick={() => {
                states[key] = "delete"
                this.setState({ states })
              }}
                size='small'
                className= {fileExtension ? 'emedhub_icon_imgCap_close' : 'emedhub_icon_img_close'}
              ><Close fontSize='small' /></IconButton>
            </div>
            </div>
            : (states[imgKey + "Cap"] !== null) ?
              <div className='emedhub_doc_image_size'>
                <img src={ImagePaths.ImagePreview.default} className='eMed_createapt_right2_field_img_inv' />
                <IconButton
                  onClick={() => {
                    this.setState({ [imgKey + "Cap"]: null, [imgKey]: null })
                  }}
                  sx={{ marginRight: 0 }}
                  size='small'
                  className='emedhub_icon_img_close'
                ><Close fontSize='small' /></IconButton>
              </div>
              : null}
        </Box>
      </Box>
    )
  }

  renderDateTimeFilter = () => {
    try {
      let today = new Date()
      let maxDate = new Date()
      if (this.state.dateLimitType === "Days") {
        maxDate.setDate(today.getDate() + this.state.dateLimit)
      } else {
        maxDate.setMonth(today.getMonth() + this.state.dateLimit);
      }
      let formatMaxDate = maxDate.toISOString()?.slice(0, 10)
      
      return (
        <Box sx={{ mt: '1vw' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              open={this.state.DateOpen}
              onOpen={() => { this.setState({ DateOpen: true }) }}
              onClose={() => { this.setState({ DateOpen: false }) }}
              inputFormat='dd-MM-yyyy & hh:mm a'
              value={this.state.appointmentDateTime}
              minDate={new Date((new Date).getFullYear(), (new Date).getMonth() - 2, 1)}
              // maxDate={new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0)}
              maxDate={formatMaxDate}
              onChange={(newDate) => {
                if (newDate === null) {
                  this.setState({ appointmentDateTime: new Date() }, () => {
                    this._getDoctorDetails()
                    this.getValidUptoData()
                  })
                }
                else {
                  this.setState({ appointmentDateTime: newDate }, () => {
                    this._getDoctorDetails()
                    this.getValidUptoData()
                  })
                }
              }}
              renderInput={(params) => <TextField size='small'
                onKeyDown={(e) => e.preventDefault()}
                onClick={() => { this.setState({ DateOpen: true }) }}
                {...params}
                fullWidth
                variant='outlined'
                label="Appointment Date & Time *"
                style={{ width: "14vw", marginRight: "0.5vw", marginLeft: "0.5vw" }}
              />}
            />
          </LocalizationProvider>
          <Button variant='outlined' disabled={this.state.selectedDocId == null || !this.state.selectedDocId?.doctor_id || !this.state.isQmsConfig} style={{ width: "14vw", height: "2.5vw" }} size="small" id="eMed_Config_btn" onClick={() => { this.getSlotIntervel() }}>{this.state.selectedSlot ? `Slot : ${this.convertTo12Hour(this.state.selectedSlot)}` : "Select Appointment Slots"}</Button>
        </Box>
      )
    } catch (e) {

    }
  }

  renderCreateAppointmentRight = () => {
    const creditType = [...(JSON.parse(localGetItem("allow_patient_credit_bills")) ? [{ label: 'Patient Credit', value: 'Patient credit' }] : []), { label: 'Corporate Credit', value: 'Corporate credit' }, 
    { label: 'Insurance Credit', value: 'Insurance credit' }
  ]
    try {
      const { t } = this.props
      var states = this.state
      let ShowOpthometrist = (this.state?.selectedSpecId?.name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false")
      let userData = JSON.parse(localGetItem("loggedInUserInfo"))
      return (
        <Stack component={'div'}>
          {
            (!this.props.isFromIP && !this.props.isForOPUpdate && !this.props.fromViewGraphics) ?
              <Paper elevation={2} className="eMed_createapt_right1" sx={{ height: ShowOpthometrist ? "51vh" : "43.9vh" }}>
                <Box backgroundColor={'#F5F8F7'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                  <Typography className='eMed_refdoc_title'>{t("Appointment Details")}</Typography>
                  {(localGetItem("display_latest_token_number")=='true' && userData?.module_name === 'front_office' && this.state.selectedDocId != null && userData?.token_gen_type=="Doctor") ? (
                    <Box
                      component="div"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "0.4rem",
                        padding: "0.2rem 0.6rem",
                        zIndex: 10
                      }}
                    >
                      <Chip
                        label={
                          <Box fontSize="0.75rem" component="span">
                            Latest Token:{" "}
                            <Box component="span" sx={{ color: "#616161", fontSize: "0.75rem", }}>
                              {this.state.doctorToken ?? "-"}
                            </Box>
                          </Box>
                        }
                        color="primary"
                        variant="outlined"
                        sx={{ fontSize: "0.75rem", height: "26px" }}
                      />
                      <Tooltip arrow title="Refresh" placement="left">
                        <Button
                          size="small"
                          onClick={() => {
                            try {
                              this.handleDoctorToken();
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                          variant="contained"
                          id="eMed_Config_btn"
                          sx={{
                            minWidth: "28px",
                            width: "28px",
                            height: "28px",
                            padding: 0,
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            '& svg': { fontSize: "16px" }
                          }}
                        >
                          {this.state.isRefreshing ? (
                            <CircularProgress
                              size={13}
                              sx={{ color: "white" }}
                            />
                          ) : (
                            <RefreshIcon />
                          )}
                        </Button>
                      </Tooltip>
                    </Box>
                  ):null}
                </Box>
                <Box className="eMed_createapt_right1_box">
                  {this.renderDropdown("Specialization", "0vw", states.spcInfo, "selectedSpecId")}
                  {this.props.is_Nurse ? this.renderDropdown("Nurse", "0vw", states.NurseList, "selectedNurseId") :
                    this.renderDropdown("Doctor", "0vw", states["filteredDocList"].length > 0 ? states.filteredDocList : states.doctorList, "selectedDocId")}
                  {ShowOpthometrist && this.renderDropdown("Optometrist", ".8vw", states.OpthometristList, "selectedOptometrist") }
                  {userData?.has_telemedicine ? this.renderDropdown("Patient Tag", ".8vw", states.tagDetails, "selectedTagId") : null}
                  {userData?.has_telemedicine ? this.renderDropdown("Appointment Type", ".8vw", states.AppointmentTypeList, "selectedAppointTypeId") : null}
                  {this.renderDateTimeFilter()}
                  {userData?.has_telemedicine ? null : this.renderDropdown("Patient Tag", ".8vw", states.tagDetails, "selectedTagId")}
                  {userData?.has_telemedicine ? null : this.renderDropdown("Appointment Type", ".8vw", states.AppointmentTypeList, "selectedAppointTypeId")}
                </Box>
                <Autocomplete
                  inputProps={{ maxLength: 250 }}
                  options={states.POVList}
                  getOptionLabel={(options) => options}
                  onChange={(e, value) => {
                    this.setState({
                      purposeOfVisit: value,
                      manuallySelected: true
                    })
                    if(!value){
                      this.setState({ manuallySelected: false })
                    }
                  }}
                  clearIcon={false}
                  size='small'
                  sx={{ m: '.8vw', width: '29vw' }}
                  value={states.purposeOfVisit}
                  renderInput={(params) => <TextField sx={{ width: "28.5vw" }} onChange={(event) => {
                    this.setState({
                      purposeOfVisit: event.target.value,
                      manuallySelected: true
                    })
                    if(event.target.value === ""){
                      this.setState({ manuallySelected: false })
                    }
                  }}
                    {...params}
                    placeholder="Purpose Of Visit *"
                  />}
                />
                {JSON.parse(localGetItem('isNewBilling')) ? <Autocomplete
                  options={creditType}
                  getOptionLabel={(options) => options?.label || options}
                  onChange={(e, value) => {
                    this.setState({
                      selectCreditType: value?.value || value,
                    })
                  }}
                  clearIcon={false}
                  size='small'
                  sx={{ m: '.8vw', width: '29vw' }}
                  value={states.selectCreditType}
                  renderInput={(params) => <TextField sx={{ width: "28.5vw" }} 
                    {...params}
                    label="Select Credit Type"
                  />}
                /> : null}

              </Paper> : null
          }
          <Paper elevation={2} sx={{ height: (this.props.isFromIP || this.props.isForOPUpdate) ? "72vh" : this.props.fromViewGraphics ? "68vh" : ShowOpthometrist ? '19vh' : "26vh" }} className="eMed_createapt_right2">
            <Typography className='eMed_refdoc_title'>{t("Identity Proof")}</Typography>
            {this.renderIdentityProof("Aadhaar", "aadharProof", "aadhar_card_number",this.state.duplicateAadharProof, "aadharProofImg")}
            {this.renderIdentityProof("PAN", "panProof", "pancard_number",this.state.duplicatePanProof, "panProofImg")}
            {this.renderIdentityProof("Passport", "passportProof", "passport_number",this.state.duplicatePassportProof, "passportProofImg")}
            {this.renderIdentityProof("Ration", "rationProof", "ration_card_number",this.state.duplicateRationProof, "rationProofImg")}
            {this.renderIdentityProof("DL", "dlProof", "dl_number",this.state.duplicateDlProof, "dlProofImg")}
          </Paper>
        </Stack>
      )
    } catch (e) {
      this.errorMessage(e)
    }
  }

  dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  async getS3Key(doc_key, stateKey) {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));
      if (response.data.status === "success") {
        const fileUrl = response.data.data;  

        // Fetch the file as a blob
        const fileResponse = await fetch(fileUrl);
        const blob = await fileResponse.blob();

        // Create an object URL for the blob
        const objectUrl = URL.createObjectURL(blob);
       this.setState({ [stateKey]: objectUrl });
      }
    } catch (e) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: "Error fetching S3 URL"
      });
    }
  }

      fetchAndConvertToBase64 = async (url) => {
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const blob = await response.blob();
          const reader = new FileReader();
          return new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader?.result);
            reader.onerror = () => reject(reader?.error);
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.error('Error fetching or converting file:', error);
        }
      }


  sendDocuments(key, filename) {
    let states = this.state;
    if (states[key] === "" || states[key] === null) {
      return "None"
    }
    else if (states[key] === "delete") {
      return "delete"
    }
    else {
      if (typeof (states[key]) === "string") {
        if (key === "patient_img") {
          if (states[key].includes("https://s3-ap-south-1.amazonaws.com")) {
            return "None"
          } else if (states[key]?.includes("amazonaws.com")) {
            return "None"
          }
          else {
            return this.dataURItoBlob(states[key])
          }

        } else if(CheckImage.has(key)){
          return dataURItoFile(states[key], filename)
        } else {
          return "None"
        }
      }
      else {
        return states[key]
      }
    }
  }

  GetAppointmentDetails(id) {
    try {
      const { history } = this.props;
      RestAPIService.getAll(Serviceurls.FO_GET_APPOINMENT_DETAILS + "?appointment_id=" + id).
        then((response) => {
          if (response.data.status === "success") {
            setCachevalue(JSON.stringify(response.data.data), "patientData")
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  postCreatePatient = (METHOD) => {
    try {
      var states = this.state
      let { history } = this.props;

      var date = new Date(states.dob)

      var Dob = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
      const dataForm = new FormData();
      dataForm.append("first_name", states.first_name === null ? "" : CommonValidation.removeSpace(states.first_name))
      dataForm.append("last_name", states.surname === null ? "" : CommonValidation.removeSpace(states.surname))
      dataForm.append("middle_name", states.middle_name === null ? "" : CommonValidation.removeSpace(states.middle_name))
      dataForm.append("father_husband_name", states.father_husband_name === null ? "" : CommonValidation.removeSpace(states.father_husband_name))
      dataForm.append("father_husband_age", states.father_husband_age === null ? "" : CommonValidation.removeSpace(states.father_husband_age))
      dataForm.append("gender", states.gender === null ? "" : states.gender)
      dataForm.append("title", states.title === null ? "" : states.title)
      dataForm.append("occupation", states.occupation === null ? "" : CommonValidation.removeSpace(states.occupation))
      dataForm.append("dob", Dob === null ? "" : Dob)
      dataForm.append("approx_dob", Dob === null ? "" : Dob)
      dataForm.append("marital_status", states.marital_status === null ? "" : CommonValidation.removeSpace(states.marital_status))
      dataForm.append("mobile_number", states.mobile_no === null ? "" : CommonValidation.removeSpace(states.mobile_no))
      dataForm.append("mobile_number_2", "")
      dataForm.append("email", states.email_id === null ? "" : CommonValidation.removeSpace(states.email_id))
      dataForm.append("address_line_1", states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1))
      dataForm.append("address_line_2", states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2))
      dataForm.append("pincode", states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code))
      dataForm.append("city_name", states.city === null ? "" : CommonValidation.removeSpace(states.city))
      dataForm.append("district", states.district === null ? "" : CommonValidation.removeSpace(states.district))
      dataForm.append("state_name", states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item)=>( item.isoCode === states.state_code))?.name))
      dataForm.append("country", states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item)=>( item.isoCode === states.country_code))?.name))
      // dataForm.append("reffered_by", states.referredBy === null ? "" : CommonValidation.removeSpace(states.referredBy))
      // dataForm.append("reffered_by", !states.refferedType ? "" : CommonValidation.removeSpace(states.refferedType))
      // dataForm.append("referral_source", !states.refferalValue ? "" : CommonValidation.removeSpace(states.refferalValue))
      // dataForm.append("referral_staff", !states.refferalValue ? "" : CommonValidation.removeSpace(states.refferalValue))
      dataForm.append("id_no", states.employee_id === null ? "" : CommonValidation.removeSpace(states.employee_id))
      dataForm.append("employer_id", states.employer_id === null ? "" : CommonValidation.removeSpace(states.employer_id))
      dataForm.append("document", states.docDocument === null ? "" : this.sendDocuments("docDocument"))
      dataForm.append("aadhar", (states.aadharProof !== null || states.aadharProofImgCap !== null) ? this.sendDocuments(states.aadharProofImgCap ? "aadharProofImgCap" : "aadharProof", "aadhar.jpg") : "")
      dataForm.append("pan", (states.panProof !== null || states.panProofImgCap !== null) ? this.sendDocuments(states.panProofImgCap ? "panProofImgCap" : "panProof", "pan.jpg") : "")
      dataForm.append("passport", (states.passportProof !== null || states.passportProofImgCap !== null) ? this.sendDocuments(states.passportProofImgCap ? "passportProofImgCap" : "passportProof", "passport.jpg") : "" )
      dataForm.append("ration_card", (states.rationProof !== null || states.rationProofImgCap !== null) ? this.sendDocuments(states.rationProofImgCap ? "rationProofImgCap" : "rationProof", "ration_card.jpg") : "")
      dataForm.append("dl", (states.dlProof !== null || states.dlProofImgCap !== null) ? this.sendDocuments(states.dlProofImgCap ? "dlProofImgCap" : "dlProof", "dl.jpg") : "")
      dataForm.append("photo", !states.patient_img ? "" : this.sendDocuments("patient_img"))
      dataForm.append("face_data", !states.patient_img ? "" : this.sendDocuments("patient_img"))
      dataForm.append("pancard_number", states.pancard_number === null ? "" : CommonValidation.removeSpace(states.pancard_number))
      dataForm.append("ration_card_number", states.ration_card_number === null ? "" : CommonValidation.removeSpace(states.ration_card_number))
      dataForm.append("dl_number", states.dl_number === null ? "" : CommonValidation.removeSpace(states.dl_number))
      dataForm.append("passport_number", states.passport_number === null ? "" : CommonValidation.removeSpace(states.passport_number))
      dataForm.append("aadhar_card_number", states.aadhar_card_number === null ? "" : CommonValidation.removeSpace(states.aadhar_card_number))
      dataForm.append("caretaker_name", states.emergency_contact_person === null ? "" : CommonValidation.removeSpace(states.emergency_contact_person))
      dataForm.append("caretaker_mobile", states.emergency_contact_mobile === null ? "" : CommonValidation.removeSpace(states.emergency_contact_mobile))
      dataForm.append("caretaker_relationship", states.relationship === null ? "" : CommonValidation.removeSpace(states.relationship))
      dataForm.append("receive_email", states.receive_email === null ? "" : states.receive_email)
      dataForm.append("receive_whatsapp", states.receive_whatsapp === null ? "" : CommonValidation.removeSpace(states.receive_whatsapp))
      dataForm.append("receive_sms", states.receive_sms === null ? "" : states.receive_sms)
      dataForm.append("insurance_company_name", states.insurance_company_name === null ? "" : CommonValidation.removeSpace(states.insurance_company_name))
      dataForm.append("policy_number", states.policy_number === null ? "" : CommonValidation.removeSpace(states.policy_number))
      dataForm.append("guardian", states.guardian === null ? "" : CommonValidation.removeSpace(states.guardian))
      dataForm.append("mother_name", states.mother_name === null ? "" : CommonValidation.removeSpace(states.mother_name))
      dataForm.append("mother_age", states.mother_age === null ? "" : CommonValidation.removeSpace(states.mother_age))
      dataForm.append("old_referral_no", states.old_referral_no === "" ? "" : CommonValidation.removeSpace(states.old_referral_no))
      dataForm.append("ip_admission_id", states.admissionId === null ? "" : CommonValidation.removeSpace(states.admissionId))
      dataForm.append("appointment_id", states.appointmentId === null ? "" : CommonValidation.removeSpace(states.appointmentId))
      dataForm.append("primary_payment_type", states.creditType === null ? "" : CommonValidation.removeSpace(states.creditType))
      dataForm.append('insurance_id', states.insurance_id ? states.insurance_id : '')
      dataForm.append('relationship_label',states.selectedFatHusName === '' ? '' : states.selectedFatHusName)
      dataForm.append('blood_group',states.blood_group ? states.blood_group : '')
      dataForm.append('caretaker_id',states.caretaker_id ? states.caretaker_id : '')
      dataForm.append('referral_description',states.refferalDesc ? states.refferalDesc : '')
      dataForm.append('rchid',states.rchid ? CommonValidation.removeSpace(states.rchid) : '')

      let selectedCorporate = states.CorporateList?.find(item => item.id === states.employer_id);
      dataForm.append("company_name", selectedCorporate ? selectedCorporate.company_name : "");

      if (this.state.refferedType === "Source") {
        dataForm.append("referral_source", !states.refferalValue  ? "" : CommonValidation.removeSpace(states.refferalValue))
      } else if (this.state.refferedType === "Doctor") {
         dataForm.append("reffered_by", !states.refferalValue  ? "" : CommonValidation.removeSpace(states.refferalValue))
      } else if(this.state.refferedType === "Staff") {
         dataForm.append("referral_staff", !states.refferalValue  ? "" : CommonValidation.removeSpace(states.refferalValue))
      }

      if ((this.props.isForOPUpdate || this.props.fromViewGraphics) && this.state.SelectedPatientID && this.state.PatientTypeConfig) {
        dataForm.append('patient_type', states.patient_type === null ? '' : (states.patient_type === "new_patient" ? 1 : states.patient_type === "review_patient" ? 2 : states.patient_type === "old_patient" ? 3 : null))
      }

      if (this.props.isFromIP || this.props.fromViewGraphics) { dataForm.append("inpatient", true) }
      if (this.state.SelectedPatientID !== "") { dataForm.append("patient_id", states.SelectedPatientID) }
      let URL = "";
      if (this.props.isFromIP || this.props.fromViewGraphics) { URL = Serviceurls.IP_PATIENT_CREATE }
      else if (this.props.isForOPUpdate || this.state.isPatientCreated || getCachevalue("OP_CreateAppointment_PatientId") !== null || this.state.RequestedPatientData?.patient_id) { URL = Serviceurls.FO_PATIENT_UPDATE }
      else if (this.props.isForIPUpdate) { URL = Serviceurls.IP_PATIENT_CREATE }
      else { URL = Serviceurls.FO_PATIENT_CREATE }
      this.LoaderFunction(true)
      if (METHOD === "POST") {
        RestAPIService.create(dataForm, URL)
          .then((response) => {
            if (response.data.status === 'success') {
              this.setState({ DisableBtn: false })
              // if((states.insurance_company_name != "" && states.insurance_company_name != null)  && states.NewInsurance){
              //   this.postNewInsurance()
              // }
              var Data = response.data.data
              if (this.props.isFromIP) {
                this.props.IpPatientRegSuccess(response?.data?.message, response?.data?.data)
              }
              else if (this.props.isForOPUpdate) {
                let patientDetails = getCachevalue("patientData")
                let patients = JSON.parse(patientDetails)

                let updatedData = JSON.parse(patientDetails)
                updatedData["patient_type"] = Data?.patient_type ? Data?.patient_type : states?.patient_type
                setCachevalue(JSON.stringify(updatedData), "patientData")

                let appointmentId = patients?.appointment_id ? patients.appointment_id : states.appointmentId
                this.getPatientDemographics()
                appointmentId && this.GetAppointmentDetails(appointmentId)
                // this.GetAppointmentDetails(appointmentId)
                this.LoaderFunction(false)
                this.successMessage(response?.data?.message)
              }
              else if (this.state.isPatientCreated) {
                this.postAppointmentCreate(this.state.SelectedPatientID)
              }
              else {
                if (Data?.patient_id) {
                  this.setState({
                    isPatientCreated: true,
                    SelectedPatientID: Data.patient_id
                  }, () => {
                    this.postAppointmentCreate(Data.patient_id)
                  })
                }
                else if (getCachevalue("OP_CreateAppointment_PatientId") !== null) {
                  this.postAppointmentCreate(getCachevalue("OP_CreateAppointment_PatientId"))
                }
                else if (this.state.RequestedPatientData?.patient_id) {
                  this.postAppointmentCreate(this.state.RequestedPatientData?.patient_id)
                }
              }
            }
          }).catch((e) => {
            if (e?.response?.data?.message) {
              this.LoaderFunction(false)
              this.errorMessage(e.response.data.message)
            } else {
              this.LoaderFunction(false)
              this.errorMessage(e.message)
            }
          })
      }
      else if (METHOD === "PUT") {
        RestAPIService.updateWithOutId(dataForm, URL)
          .then((response) => {
            if (response.data.status === 'success') {
              if (this.props.isFromIP) {
                this.props.IpPatientRegSuccess(response?.data?.message, response?.data?.data)
              } else if (this.props.fromViewGraphics) {
                this.LoaderFunction(false)
                this.getPatientDemographics(response?.data?.data)
                this.successMessage(response?.data?.message)
              }
            }
          }).catch((e) => {
            if (e?.response?.data?.message) {
              this.LoaderFunction(false)
              this.errorMessage(e.response.data.message)
            } else {
              this.LoaderFunction(false)
              this.errorMessage(e.message)
            }
          })
      }


    } catch (e) {
      if (e?.response?.data?.message) {
        this.errorMessage(e.response.data.message)
      } else {
        this.errorMessage(e.message)
      }

    }
  }

  convertTo24Hour = (time12h) => {
    const [time, period] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (period.toLowerCase() === 'pm' && hours !== '12') {
      hours = String(Number(hours) + 12);
    }

    if (period.toLowerCase() === 'am' && hours === '12') {
      hours = '00';
    }

    return `${hours}:${minutes}:00`;
  }

  postAppointmentCreate = (id) => {
    var states = this.state
    let { history } = this.props;

    var AptDateTime = new Date(states.appointmentDateTime)

    var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')

    var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

    let selectedCorporate = states.CorporateList?.find(item => item.id === states.employer_id);

    var data = {
      patient_id: id,
      doctor_id: states.selectedDocId?.doctor_id ? states.selectedDocId?.doctor_id : null,
      speciality_id: states.selectedSpecId?.id ? states.selectedSpecId?.id : null,
      purpose_of_visit: states.purposeOfVisit,
      patient_tag_id: states.selectedTagId?.id,
      appointment_date: AptDate,
      appointment_start_time: this.state.selectedSlot != "" ? `${this.state.selectedSlot}:00` : Aptime,
      patient_appointment_type: states.selectedAppointTypeId === null ? null : states.selectedAppointTypeId?.id,
      nurse_id: states.selectedNurseId?.staff_id ? states.selectedNurseId?.staff_id : null,
      request_id: this.state.RequestedPatientData?.id ? this.state.RequestedPatientData?.id : null,
      qr_request_id: this.state.QRPatientData?.id ? this.state.QRPatientData?.id : null,
      followup_id: this.state.followupID ? this.state.followupID : null,
      optometrist_id: (this.state.selectedOptometrist?.id && this.state?.selectedSpecId?.name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false") ? this.state.selectedOptometrist?.id : null,

      // credit type in appointment
      primary_payment_type: states.selectCreditType === 'Corporate credit' ? 'Corporate credit' : states.selectCreditType === 'Insurance credit' ? 'Insurance credit' : states.selectCreditType === null ? "" : CommonValidation.removeSpace(states.selectCreditType),
      company_name: selectedCorporate ? selectedCorporate.company_name : "",
      id_no: states.employee_id === null ? "" : CommonValidation.removeSpace(states.employee_id),
      employer_id: states.employer_id === null ? "" : CommonValidation.removeSpace(states.employer_id),
      insurance_company_name : states.insurance_company_name === null ? "" : CommonValidation.removeSpace(states.insurance_company_name),
      policy_number : states.policy_number === null ? "" : CommonValidation.removeSpace(states.policy_number),
    }  
 

    RestAPIService.create(data, Serviceurls.FO_PATIENT_APPOINTMENT)
      .then((response) => {
        if (response.data.status === 'success') {
          clearCachevalue("OP_CreateAppointment_PatientId");
          clearCachevalue("AppRequestPatientData");
          clearCachevalue("QRRequestPatientData");
          this.LoaderFunction(false)
          history.push({ pathname: "/OPHome", state: { NewAppointmentCreated: true, NewMessage: response.data?.message } })
          this.props.changeNursestate(false)
          this.setState({
            selectedSlot : "",
            DisableBtn: false,
          })
        }
      }).catch((e) => {
        this.LoaderFunction(false)
        if (e?.response?.data?.message) {
          this.errorMessage(e.response.data.message)
        } else {
          this.errorMessage(e.message)
        }
      })


  }

  MandatoryCheck() {
    let states = this.state;
    let MandatoryCount = +(states.mandotory_count)
    let flag = false;
    for (let i = 0; i < MandatoryCount; i++) {
      if (CommonValidation.removeSpace(states[states.layoutData[i].field_name]) === "" || states[states.layoutData[i].field_name] === null) {
        flag = false
        this.errorMessage(`${states.layoutData[i].label} is Mandatory !`)
        break
      } else if(states.layoutData[i].field_name === 'father_husband_name' && states[states.layoutData[i].field_name] !== '' && states['selectedFatHusName'] === ''){
        flag = false
        this.errorMessage('Select Father/Spouse Releationship')
        break;
      } else {
        flag = true
      }
    }
    if(flag){
        if(states.refferedType){
            if(!states.refferalValue){
                flag = false
                this.errorMessage("Select Referral detail")
            }
        }
    }
    return flag
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  Validation() {
    let states = this.state;
    let Email = (states.MandatoryLabels.includes("Email ID") || states.email_id !== "") ? CommonValidation.emailValidation(states.email_id) : true;
    Email = states.email_id == null ? true : true;
    let Corporate = (states.employer_id === "" || states.employer_id === null) ? true : (states.employee_id !== "" && states.employee_id !== null)
    let Insurance = (states.insurance_company_name === "" || states.insurance_company_name === null) ? true : (states.policy_number !== "" && states.policy_number !== null)
    let InsuranceMandatory = states.selectCreditType === 'Insurance credit' ? (states.insurance_company_name !== '' && states.insurance_company_name !== null) : true
    let CorporateMandatory = states.selectCreditType === 'Corporate credit' ? (states.employer_id !== '' && states.employer_id !== null) : true
    if (this.state.rchError) return this.errorMessage("Invalid RCH ID") 
    if (this.MandatoryCheck()) {
      if (this.props.isFromIP === true || this.props.fromViewGraphics === true) {  // IP Validaions
        if (states.mobile_no.length === 10 && Email && Corporate && Insurance && states.dob != "Invalid Date" && (this.state.dob < new Date() && this.state.dob > new Date("1872-01-01"))) {
          this.postCreatePatient(this.state.isForIPUpdate ? "PUT" : "POST")
        }
        else {
          this.setState({ DisableBtn: false }, () => {
            if (states.mobile_no.length !== 10) { this.errorMessage("Invalid Mobile Number") }
            else if (!Email) { this.errorMessage("Invalid Email ID") }
            else if (states.dob == "Invalid Date") { this.errorMessage("Invalid Date of Birth") }
            else if (!(this.state.dob < new Date() && this.state.dob > new Date("1872-01-01"))) { this.errorMessage("Invalid Date of Birth") }
            else if (!Corporate) { this.errorMessage("Employee ID No is empty") }
            else if (!Insurance) { this.errorMessage("Insurance Policy No is empty") }
          })
        }
      }
      else {     // OP Validaions
        if (this.props.isForOPUpdate) {
          if ((this.props.isForOPUpdate && states.mobile_no.length === 10 && Email && Corporate && Insurance && states.dob != "Invalid Date" && (this.state.dob < new Date() && this.state.dob > new Date("1872-01-01")))) {
            if((states.creditType === "Insurance credit" && states.insurance_company_name === '') || (this.state.creditType === "Corporate credit" && !states.employer_id)){
              if(!JSON.parse(localGetItem("allow_patient_credit_bills"))){
                this.errorMessage("eigher Insurance or Corporate details should be filled")
              }else{
                this.setState({ confirmationPop: true })
              }
            }else{
              this.postCreatePatient("POST")
            }
          } else {
            this.setState({ DisableBtn: false }, () => {
              if (states.mobile_no.length !== 10) { this.errorMessage("Invalid Mobile Number") }
              else if (!Email) { this.errorMessage("Invalid Email ID") }
              else if (states.dob == "Invalid Date") { this.errorMessage("Invalid Date of Birth") }
              else if (!(this.state.dob < new Date() && this.state.dob > new Date("1872-01-01"))) { this.errorMessage("Invalid Date of Birth") }
              else if (!Corporate) { this.errorMessage("Employee ID No is empty") }
              else if (!Insurance) { this.errorMessage("Insurance Policy No is empty") }
            })
          }
        } else {
          if (((this.props.is_Nurse ? (states.selectedNurseId !== null) : ((states.selectedDocId !== null || !this.state.isDoctorMandatory ) && states.selectedSpecId !== null)) && (this.state?.selectedSpecId?.name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false" ? states.selectedOptometrist : true) && DateTime.fromJSDate(states.appointmentDateTime).toFormat('yyyy-MM-dd') !== "Invalid DateTime" && (new Date((new Date).getFullYear(), (new Date).getMonth() - 2, 1) < states.appointmentDateTime && new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0) > states.appointmentDateTime) && states.mobile_no.length === 10 && Email && states.dob != "Invalid Date" && (this.state.dob < new Date() && this.state.dob > new Date("1872-01-01")) && Corporate && Insurance && InsuranceMandatory && CorporateMandatory && CommonValidation.removeSpace(this.state.purposeOfVisit) !== "")) {
              this.postCreatePatient("POST")
          } else {
            this.setState({ DisableBtn: false }, () => {
              if (states.mobile_no.length !== 10) { this.errorMessage("Invalid Mobile Number") }
              else if (states.dob == "Invalid Date") { this.errorMessage("Invalid Date of Birth") }
              else if (!Email) { this.errorMessage("Invalid Email ID") }
              else if (!(this.state.dob < new Date() && this.state.dob > new Date("1872-01-01"))) { this.errorMessage("Invalid Date of Birth") }
              else if (!Corporate) { this.errorMessage("Employee ID No is empty") }
              else if (!Insurance) { this.errorMessage("Insurance Policy No is empty") }
              else if (!InsuranceMandatory) { this.errorMessage("Insurance Company Name is mandatory") }
              else if (!CorporateMandatory) { this.errorMessage("Corporate Company Name is mandatory") }
              else if (this.props.is_Nurse && states.selectedNurseId === null) { this.errorMessage("Select Nurse") }
              else if (this.props.is_Nurse === false && states.selectedSpecId === null) { this.errorMessage("Select Specialization") }
              else if (this.props.is_Nurse === false && (states.selectedDocId === null && this.state.isDoctorMandatory)) { this.errorMessage("Select Doctor") }
              else if (this.props.is_Nurse === false && (states.selectedOptometrist === null && this.state?.selectedSpecId?.name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false")) { this.errorMessage("Select Opthometrist") }
              else if (CommonValidation.removeSpace(this.state.purposeOfVisit) === "") { this.errorMessage("Enter Purpose of Visit") }
              else if ((DateTime.fromJSDate(states.appointmentDateTime).toFormat('yyyy-MM-dd') === "Invalid DateTime" || !(new Date((new Date).getFullYear(), (new Date).getMonth() - 2, 1) < states.appointmentDateTime && new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0) > states.appointmentDateTime))) { this.errorMessage("Invalid Appointment Date & Time !") }
            })
          }
        }

      }
    }
  }

  ClearData() {
    clearCachevalue("OP_CreateAppointment_PatientId");
    clearCachevalue("AppRequestPatientData");
    clearCachevalue("QRRequestPatientData");
    this.setState({
      referredBy: "",
      refferalValue: "",
      refferedType : "",
      referralSource: "",
      mobile_no: "",
      first_name: "",
      age: "",
      dob: null,
      gender: "",
      title: "",
      middle_name: "",
      surname: "",
      address_1: "",
      address_2: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      employer_id: null,
      employee_id: "",
      email_id: "",
      marital_status: "",
      father_husband_name: "",
      father_husband_age: "",
      occupation: "",
      emergency_contact_person: "",
      emergency_contact_mobile: "",
      relationship: "",
      docDocument: null,
      aadharProof: null,
      panProof: null,
      passportProof: null,
      rationProof: null,
      dlProof: null,
      aadharProofImg: null,
      panProofImg: null,
      passportProofImg: null,
      rationProofImg: null,
      dlProofImg: null,
      aadharProofImgCap: null,
      panProofImgCap: null,
      passportProofImgCap: null,
      rationProofImgCap: null,
      dlProofImgCap: null,
      selectedDocId: null,
      selectedOptometrist: null,
      selectedSpecId: null,
      selectedTagId: null,
      appointmentDateTime: new Date(),
      purposeOfVisit: null,
      pancard_number: "",
      ration_card_number: "",
      dl_number: "",
      passport_number: "",
      aadhar_card_number: "",
      insurance_company_name: null,
      policy_number: "",
      insurance_id: '',
      guardian: "",
      patient_img: null,
      temp_patient_img: null,
      selectedAppointTypeId: this.state.AppointmentTypeList.find((item) => (item.appoinment_type === "Walk in Appointment")),
      filteredDocList: [],
      isPatientCreated: false,
      SelectedPatientID: "",
      mother_name: "",
      mother_age: "",
      RequestedPatientData: {},
      old_referral_no: "",
      QRPatientData: [],
      manuallyChanged: false,
      selectedFatHusName:'',
      manuallySelected: false,
      blood_group: '',
      ccn_number: '',
      district: '',
      caretaker_id: '',
      rchid:'',
      hasFutureAppointment: false,
      hasValid: false,
    }, ()=>{
    let city_name = localGetItem('city_name')
    let state_name = localGetItem('state_name')
    let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
    let stateList = State.getStatesOfCountry(List?.countryCode)
    let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
    this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList })
      if(this.props?.OpCreate){
        this.props.VisitDateBalAmount({})
      }
    })
  }

  PreviewPopClose() { this.setState({ SelectedDocSRC: null }) }

  getIpPatientData = (patientId) => {
    try{
      RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + '?patient_id=' + patientId).
      then((response) => {
        if(response?.data?.status === 'success'){
          this.setState({
            ipPatientListData:response?.data?.data
          },() => {
            this.props.history.push({ pathname: "/IPHome/CreateAppointment", state: { SelectedPatientDetails: this.state.ipPatientListData, PatientClicked: true } })
          })
        }
      }).catch((error) => {
        if(error?.response?.data?.message){
          this.errorMessage(error?.response?.data?.message)
        }else{
          this.errorMessage(error?.message)
        }
      })
    }catch(error){
      this.errorMessage(error.message)
    }
  }

  SameNumberPatientPop() {
    let { t } = this.props;
    return (
      <Modal open={true}>
        <Box className="eMed_MobileNum_Main">
          <Box component={'div'} className="eMed_MobileNum_Header">
            <Typography variant='h6'>{"Patient List"}</Typography>
            <IconButton onClick={() => { this.setState({ SameMobileNumPatients: [] }) }} marginRight={'4vw'}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
            </IconButton>
          </Box>
          <Box component={'div'} className="eMed_MobileNum_wrapper">
            {
              this.state.SameMobileNumPatients.length > 0 ?
                this.state.SameMobileNumPatients.map((list) => {
                  let PatientFullName = `${list.first_name} ${list.last_name}`
                  list["patient_name"] = PatientFullName
                  list["patient_mobile_number"] = list.mobile_number
                  list["patient_photo_url"] = list.photo_url
                  return (
                    <Box>
                      <Box className="eMed_Patient_Num_Search_pop">
                        <CommonPatientDetails data={list} />
                        {this.props.isFromIP ?          // For IP Appointment
                          <Tooltip title={t("CreateAppointment")} arrow>
                            <IconButton disabled={list.is_admitted} onClick={() => {
                              this.getIpPatientData(list?.patient_id)
                            }} position="end">
                              <PersonAddAlt1Icon sx={{ color: list.is_admitted ? Colors.disableLabelColor : Colors.themeDark }} />
                            </IconButton>
                          </Tooltip>
                          :                           // For OP Appointment
                          (
                            (list.appointment_date === "" || list.appointment_date !== "") || 
                          list.appointment_status === "Cancelled") ? <Tooltip title={t("CreateAppointment")} arrow>
                            <IconButton onClick={() => {
                              setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                              this.setState({
                                SelectedPatientID: list.patient_id,
                                SameMobileNumPatients: []
                              }, () => { this.getPatientDemographics() })
                            }} position="end">
                              <PersonAddAlt1Icon color={'primary'} />
                            </IconButton>
                          </Tooltip> : <Typography fontSize={'0.8vw'}>{list.appointment_date}</Typography>
                        }
                      </Box>
                      <Divider />
                    </Box>
                  )
                }) : null
            }
          </Box>
        </Box>
      </Modal>
    )
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  popupClose = () => {
    this.setState({ confirmationPop: false })
  }

  removeInsurance = () => {
    this.setState({
      creditType: "Patient credit",
      confirmationPop: false,
    }, () => this.postCreatePatient("POST"))
  }

  render() {
    const { t, fromViewGraphics } = this.props    
    return (
      <Box component={"div"} className={fromViewGraphics ? 'eMed_bill_ipContainer' : 'eMed_bill_container'}>
        <Grid container className={fromViewGraphics ? 'eMed_bill_ipContent' : 'eMed_bill_content'} >
          <Grid container className={fromViewGraphics ? 'eMed_bill_ipContent1' : 'eMed_bill_content1'} spacing={fromViewGraphics ? 1 : 2}>
            <Grid item xs={8}>
              {this.renderCreateAppointmentLeft()}
            </Grid>
            <Grid item xs={4}>
              {this.renderCreateAppointmentRight()}
            </Grid>
          </Grid>
          <Box className={fromViewGraphics ? 'eMed_bill_content2 eMed_bill_Ipcontent2' : 'eMed_bill_content2'}>
            <Button variant='outlined' size="small" id="eMed_Config_btn" sx={{ mr: '1vw' }} onClick={() => { this.ClearData() }}>{t("Clear")}</Button>
            <Button disabled={(this.state.isLoader || this.state.DisableBtn) ? true : this.props.isForOPUpdate && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)} emed_tid="demographics_update_btn" variant='contained' size="small" id="eMed_Config_btn" sx={{ ml: '1vw' }} onClick={() => { this.setState({ DisableBtn : false }, ()=>{this.Validation()}) }}>{this.props.isFromIP === true ? t("NewRegistration") : (this.props.isForOPUpdate || this.props.fromViewGraphics) ? t("Update") : t("CreateAppointment")}</Button>
          </Box>
        </Grid>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.ProfilePicClicked ? this.OpenWebCamPopUP() : null}
        {this.state.slotPopup ? this.OpenAppointmentSlotPopUP() : null}
        {this.state.imgCapClked && this.OpenWebCamIdPopUP()}
        {this.state.SelectedDocSRC !== null ?
          <CommonImgPreviewPop src={this.state.SelectedDocSRC} title={"Document Preview"} PopClose={this.PreviewPopClose.bind(this)} /> : null}
        {
          this.state.pdfPreview ?
            <PrintPreviewPop
              Data={this.state.pdfData}
              Title={t("PDF Preview")}
              ClosePopUp={this.ClosePopUp.bind(this)}
              history={this.props.history}
            /> : null
        }
        {this.state.SameMobileNumPatients.length > 0 ? this.SameNumberPatientPop() : null}
        {this.state.confirmationPop ?
          <DeletePopup
            DeletTitle={`Are you sure do you want to remove Insurance/Corporate ?`}
            deleteAlertPopupClose={this.popupClose.bind(this)}
            removeData={this.removeInsurance.bind(this)}
            DeleteNotify={"If Insurance/Corporate removed then bills will move to the patient credit automatically"}
            disable={this.state.disableBtn}
          /> : null}
        <Loader loaderOpen={this.state.isLoader} />
        {this.dialogPopup()}
      </Box>
    )
  }
}

export default withTranslation()(CreateApppointment);